import React, { Fragment, useEffect, useState, forwardRef, useRef, createRef, useMemo } from 'react'
import G from '../../../../../../util/globalFunction'
import tremApi, {nullCheckParameter, nullExceptParameter} from '../../../../../../util/tremApi'
import tremSession from '../../../../../../util/tremSession'
import { FileUploader } from '../../../../../../util/tremUpload'
import { getFormData } from '../../../../../../util/tremEntryForm'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faAngleLeft} from '@fortawesome/free-solid-svg-icons'

import DatePicker from 'react-datepicker'
import ko from 'date-fns/locale/ko'

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import FullCalendarCustom from '../../../../../../components/fullCalendar'

import Countdown from 'react-countdown'

import moment from 'moment'
import EquipMro from '../detailSub/component/equipMro'
import EquipUseMethod from './component/equipUseMethod'
import EquipOperSp from './component/equipOperSp'
import ModalBox, { usePopup } from '../../../../../../components/modalBox'
import ReservCharge from '../popup/popupReservationCharge'
import PopupUserSelect from '../../../../component/popup/popupUserSelect'
import PopupDeptSelect from '../../../../component/popup/popupDeptSelect'
import PopupExpertSelect from '../../../../component/popup/popupExpertSelect'
import { serverUrl, serverPrefixUrl } from '../../../../../../config'

import TF from '../../../../../../util/tremFunction'
import Cookies from 'js-cookie'
import * as R from 'ramda'

export default props => {
    const params = props?.params

    const startDateRef = useRef(null);

    useEffect(async () => {
     
        if(params?.EQUIP_SKEY) {
            const userSkey = await tremSession.getUserSkey()
            if(R.isNil(userSkey)) {
                 alert(G.t('trem.lang.home.0697'), G.t('trem.lang.home.1137'), ()=>{G.gotoPage('/login')})    /* 로그인 후 이용가능합니다. */
            } else {
                //차단여부 검사
                tremApi(
                    '/hm/nBlacklist/blockCheck/json',
                    {
                        BLOCK_TYPE: 'EQ',
                        EQ_ROOM_SKEY: params?.EQ_ROOM_SKEY,
                        BLACK_TARGET_SKEY: params?.EQUIP_SKEY,
                        EVAL_TYPE: 'P',
                        BLACK_TARGET: userSkey
                    }
                ).then(async blockCnt => {
                    if(blockCnt > 0) {
                        blackPopupProps.setOpen(true)
                    } else {
                        
                        params?.FIR_FLAG === 'Y'
                        ?tremApi("/equipFirstCome/hm/info/json", {
                                FIR_FLAG: params?.FIR_FLAG,
                                FIR_CM_SCH_SKEY: params?.FIR_CM_SCH_SKEY,
                                EQUIP_SKEY: params?.EQUIP_SKEY
                            }).then(data => {
                                const goDetail = (tabIdx) => {
                                    G.gotoPage(`/home/equip/reserv/detail`, {...params, tabIdx, pageParams: {EQ_ROOM_SKEY: params.EQ_ROOM_SKEY, ATTR_SKEY: params.ATTR_SKEY}})
                                }
                                
                                if(data.OPEN_FLAG == "Y"){
                                    if((data.USER_CNT || 0) > data.APPLY_CNT){
                                        data.USE_OPT_FLAG == 'Y' && data.FIR_OC_FLAG == 'Y' 
                                            && data.OC_RESERV_MAX <= data.BELONG_APPLY_CNT //수시접수 소속인원 초과
                                        ? alert(G.t('trem.lang.home.0698'), '알림',  function(){goDetail(0)}) /*예약 소속인원이 초과되었습니다.*/ 
                                        : data.USE_OPT_FLAG == 'Y' && data.FIR_RG_FLAG == 'Y' 
                                            && data.RE_RESERV_MAX <= data.BELONG_APPLY_CNT //정기접수 소속인원초과
                                        ? alert(G.t('trem.lang.home.0698'), '알림',  function(){goDetail(0)}) /*예약 소속인원이 초과되었습니다.*/
                                        :  getReservDetail(userSkey, params.EQUIP_SKEY, params.OPER_LIST[0].OPER_SKEY, params.FIR_CM_SCH_SKEY)
                                        
                                    }else{
                                        alert(G.t('trem.lang.home.0699'), '알림',  function(){goDetail(0)}) //예약 인원이 초과되었습니다.
                                    }
                                }else{
                                    data.OPEN_NOTICE
                                    ? alert(data.OPEN_NOTICE, '알림', function(){goDetail(0)})
                                    : alert(G.t('trem.lang.home.0700'), '알림', function(){goDetail(0)}) //선착순예약 신청기간이 아닙니다.
                                }
                            }) : getReservDetail(userSkey, params.EQUIP_SKEY, params.OPER_LIST[0].OPER_SKEY, params.FIR_CM_SCH_SKEY)
                    }
                })
             
            }
        }
    }, [params])

    //시험분석 의뢰서 양식 ref
    const formRef = useRef(null) 

    // 영역 제어(열림, 닫힘)
    const [areaControll, setAreaControll] = useState([]) 

    //초기데이터 풀
    const [dataStore, setDataStore] = useState({
        reservData: { //장비예약 정보
            equipMstr: {},
            requesterUserInfo: {},
            equipOperInfo: {},
            equipOperSpList: [],
            discountList: [],
            penaltyList: [],
            mroSubList: [],
            mroOptSubList: [],
            eduList: [],
            managerFlag: false,
            equipFirstComeList: [],
        },
        paramData: {}, //파라미터 풀
    })

    const { reservData, paramData } = dataStore
    const {
        equipMstr,
        requesterUserInfo,
        equipOperInfo,
        equipOperSpList,
        discountList,
        penaltyList,
        mroSubList,
        mroOptSubList,
        eduList,
        managerFlag,
        equipFirstComeList = [],
    } = reservData

    //시간중첩 문구
    const [noticeData, setNoticeData] = useState({
        noticeFlag: false,
        noticeMsg: ''
    })
    const {noticeFlag, noticeMsg} = noticeData

    // 파일업로더 사용 위한 저장소
    const [attachFileInfo, setAttachFileInfo] = useState({
        ATTACH_SKEY : null, // 첨부키
        fileList : [], // 첨부파일리스트
        readOnly : false, // 편집(삭제, 업로드) 가능여부
        oneFileOnly : false, // 파일 개수 (업로드 시 사용)
        imageView : false, // 이미지로 조회 여부
        useUploadCallbackFlag : false, // 업로드 콜백 사용여부
        uploadedFlag : false, // 업로드 시 true로 변경됨.
        usedeletedCallbackFlag : false, // 삭제 콜백 사용여부
        deletedFlag : false, // 삭제 시 true로 변경됨.
        fileUploadExtension:"",// 파일 업로드시 확장명 체크.
    })

    /*
        유저 정보
        유저 권한 정보
        특수예약 리스트
        할인정책 리스트
        패널티정책 리스트
        선착순 리스트
        실험재료 리스트
        부가서비스 리스트
        교육병행 교육정보 리스트
        장비담당자(관리자) 정보
    */
    //예약 정보 가져오기(처음, 예약옵션 바뀔때, 선착순옵션 바뀔때)
    const getReservDetail = async (USER_SKEY, EQUIP_SKEY, OPER_SKEY, FIR_CM_SCH_SKEY = '') => {

        let searchParams = { USER_SKEY, EQUIP_SKEY, OPER_SKEY, FIR_CM_SCH_SKEY }

        //예약장비 정보
        const reservData = await tremApi('/r/hm/equipReservation/detail/reserv', searchParams)
        const {
            equipMstr,
            requesterUserInfo,
            equipOperInfo,
            equipOperSpList,
            discountList,
            penaltyList,
            mroSubList,
            mroOptSubList,
            eduList,
            managerFlag,
            equipFirstComeList,
        } = reservData

        //초기값 세팅
        const paramData = getInitData(reservData)
        let eventList = []
        let selectStart = null
        let selectEnd = null

        if(equipOperInfo.FLAG_AUTO_TIME != 'Y') {
            //FullCalendar 초기값
            let startDtStr = moment(paramData.defaultDate).format('YYYY-MM-DD')
            let endDtStr = moment(paramData.defaultDate).add(1, 'days').format('YYYY-MM-DD')
            if(equipOperInfo.TIME_UNIT === '1') {
                startDtStr = moment(paramData.defaultDate).format('YYYY-MM-01')
                endDtStr = moment(paramData.defaultDate).add(1, 'months').format('YYYY-MM-DD')                
            }

            const param = {
                EQUIP_SKEY          : equipMstr.EQUIP_SKEY,
                START_DT_STR        : startDtStr,
                END_DT_STR          : endDtStr,
                AUTH_TYPE           : requesterUserInfo.AUTH_TYPE,
                BOOKING_TYPE        : paramData.BOOKING_TYPE,
                OPER_SKEY           : equipOperInfo.OPER_SKEY,
                DUPICATE_RESERV_FLAG: equipOperInfo.DUPICATE_RESERV_FLAG || 'N',
                FLAG_NOT_OBSERVER   : equipOperInfo.FLAG_NOT_OBSERVER || 'N',
                FLAG_ALL_AUTH       : equipOperInfo.FLAG_ALL_AUTH || "N",
                FLAG_ATTACH_FILE    : equipOperInfo.FLAG_ATTACH_FILE || "N",
                SCHED_KIND          : equipOperInfo.SCHED_KIND,
                RECESS_FLAG         : equipOperInfo.RECESS_FLAG,
                TIME_UNIT           : equipOperInfo.TIME_UNIT,

                lang                : 'ko',
                //선착순
                FIR_CM_SCH_SKEY	    : equipMstr.FIR_CM_SCH_SKEY,
                FIR_RG_FLAG		    : equipMstr.FIR_RG_FLAG, //정기예약여부
                RG_RESERV_TYPE	    : equipMstr.RG_RESERV_TYPE, //정기유형
                FIR_OC_FLAG		    : equipMstr.FIR_OC_FLAG, //수시예약여부
                OC_RESERV_TYPE	    : equipMstr.OC_RESERV_TYPE, //수시유형
            }
            
            eventList = await tremApi('/r/hm/equipReservation/reservation/calendar',  nullCheckParameter(param)).then(data => {
                if(equipOperInfo.TIME_UNIT === '1') {
                    data.map((obj) => {
                        obj.start = moment(obj.start).format('YYYY-MM-DD')
                        obj.end = moment(obj.end).format('YYYY-MM-DD')
                        return obj
                    })
                }
                return data
            })

            //선착순 예약 지정일
            if(equipMstr.USE_OPT_FLAG === "Y" 
                && ((equipMstr.FIR_RG_FLAG == "Y" && equipMstr.RG_RESERV_TYPE == "02") 
                || (equipMstr.FIR_OC_FLAG == "Y" && equipMstr.OC_RESERV_TYPE == "02"))) {                        
                    
                let firReservStartDate = equipMstr.RESERV_START_DT_STR
                if(equipOperInfo.TIME_UNIT == '1') {
                    firReservStartDate = moment(firReservStartDate).format("YYYY-MM-DD")
                }
                let firReservEndDate = equipMstr.RESERV_END_DT_STR
                if(equipOperInfo.TIME_UNIT == '1' && moment(firReservEndDate).format('HH:mm') != '00:00') {
                    firReservEndDate = moment(firReservEndDate).add(1, 'days').format("YYYY-MM-DD")
                }

                const param = {
                    defaultDate : paramData.defaultDate,
                    firReservStartDate,
                    firReservEndDate,
                    timeUnit : equipOperInfo.TIME_UNIT,
                    firRgFlag : equipMstr.FIR_RG_FLAG, //정기예약여부
                    firOcFlag : equipMstr.FIR_OC_FLAG, //수시예약여부
                    rgReservType : equipMstr.RG_RESERV_TYPE, //정기 유형
                    rgAccessFlag : equipMstr.RG_ACCESS_FLAG, //접속일 기준 여부
                    rgReservStartSdt : equipMstr.RG_RESERV_START_SDT || 1, //정기 예약시작일
                    rgReservEndSdt : equipMstr.RG_RESERV_END_SDT, //정기 예약종료일
                    ocReservType : equipMstr.OC_RESERV_TYPE, //수시 유형
                    ocAccessFlag : equipMstr.OC_ACCESS_FLAG, //접속일 기준 여부
                    ocReservStartSdt : equipMstr.OC_RESERV_START_SDT || 1, //수시 예약시작일
                    ocReservEndSdt : equipMstr.OC_RESERV_END_SDT, //수시 예약종료일
                }
                
                selectStart = getFristComeExtrStart(param)
                if(equipOperInfo.TIME_UNIT === '1' && equipMstr.HOLIDAY_FLAG === 'BD') {
                    selectStart = await checkSelectStart(selectStart, reservData)
                }

                selectEnd = getFirstComeExtrEnd(selectStart, param)
                
                setSelectCalendarEvent(selectStart, selectEnd, eventList, reservData)
                let useTime = 0
                if(equipOperInfo.TIME_UNIT != "1") {
                    useTime = moment(selectEnd).diff(selectStart, "hours", true)
                    useTime = Math.round(useTime*100)/100
                }else {
                    useTime = moment(selectEnd).diff(selectStart, "days", true) + 1
                }
                
                paramData['USE_TIME'] = useTime
                    
            } 

            // 선점예약 체크
            else if(paramData.FLAG_PREEMPTIVE === "Y") {
                const preemptiveData = await tremApi(
                    "/r/hm/equipReservation/reservation/preemptive/detail", 
                    {EQUIP_SKEY: equipMstr.EQUIP_SKEY}
                )
    
                if(preemptiveData) {
                    selectStart = moment(preemptiveData.START_DT_STR)._d
                    selectEnd = moment(preemptiveData.END_DT_STR)._d
                    
                    setSelectCalendarEvent(selectStart, selectEnd, eventList, reservData)

                    let useTime = 0
                    if(equipOperInfo.TIME_UNIT != "1") {
                        useTime = moment(selectEnd).diff(selectStart, "hours", true)
                        useTime = Math.round(useTime*100)/100
                    }else {
                        useTime = moment(selectEnd).diff(selectStart, "days", true) + 1
                    }

                    paramData['USE_TIME'] = useTime
                    paramData['PREEMPTIVE_SKEY'] = preemptiveData.PREEMPTIVE_SKEY
                    paramData['PT_END_DT'] = preemptiveData.PT_END_DT
                }else {
                    setCalEvents(eventList)
                }
            } else {
                setCalEvents(eventList)

            }

        }else {
            setCalEvents([])
        
        }

        setDataStore({
            reservData: reservData,
            paramData : nullCheckParameter(paramData)
        })
        setAttachFileInfo({...attachFileInfo, fileList : [], fileUploadExtension : equipOperInfo?.ATTACH_EXTENSION})
        setCalEventSource(eventList)
        setPickerDate(selectStart? selectStart : paramData.defaultDate)
        setRangeDate({startDate: selectStart, endDate: selectEnd})
        setTempDate(null)

        setSpChkData([])
        document.querySelectorAll(".chk").forEach(function(v, i) {
			v.checked = false;
		});
    }

    const getInitData = (reservData) => {

        const {
            equipMstr,
            requesterUserInfo,
            equipOperInfo,
            equipOperSpList,
            discountList,
            penaltyList,
            mroSubList,
            mroOptSubList,
            eduList,
            managerFlag,
            equipFirstComeList,
        } = reservData

        const timeUnit = equipOperInfo.TIME_UNIT
        const reservFence = equipOperInfo.RESERV_FENCE || 0
        const reservFenceMax =
            !equipOperInfo.RESERV_FENCE_MAX || equipOperInfo.RESERV_FENCE_MAX == 0
                ? 9999
                : equipOperInfo.RESERV_FENCE_MAX
        let reservFenceM = equipOperInfo.RESERV_FENCE_M || 0
        let reservFenceMaxM = equipOperInfo.RESERV_FENCE_MAX_M || 0
        let defaultDate = moment(new Date()).format('YYYY-MM-DD') // 기본예약일
            defaultDate = moment(defaultDate).add(reservFence, 'days')._d
        //선착순 예약
        if(equipMstr.FIR_FLAG === "Y" && equipMstr.FIR_CM_SCH_SKEY && equipMstr.RESERV_START_DT_STR) {
            if(moment(equipMstr.RESERV_START_DT_STR, 'YYYY-MM-DD')._d > new Date()) {
                defaultDate = moment(equipMstr.RESERV_START_DT_STR, 'YYYY-MM-DD')._d
            }
        }
        let maxDate = moment(new Date()).format('YYYY-MM-DD') // 최대예약일
            maxDate = moment(maxDate).add(reservFenceMax, 'days').add(-1, 'minutes')._d

        //선착순 예약
        if(equipMstr.FIR_FLAG === "Y" && equipMstr.FIR_CM_SCH_SKEY && equipMstr.RESERV_START_DT_STR) {
            if(moment(equipMstr.RESERV_START_DT_STR, 'YYYY-MM-DD')._d > new Date()) {
                defaultDate = moment(equipMstr.RESERV_START_DT_STR, 'YYYY-MM-DD')._d
            }
            
            if(timeUnit != '1' && moment(equipMstr.RESERV_END_DT_STR).hours() === 0 && moment(equipMstr.RESERV_END_DT_STR).minutes() === 0){
                maxDate = moment(equipMstr.RESERV_END_DT_STR, "YYYY-MM-DD").add(-1, 'd')._d
            }else{
                maxDate = moment(equipMstr.RESERV_END_DT_STR, "YYYY-MM-DD")._d
            }
        }else if (timeUnit != '1') {
            if (reservFenceMaxM == 0) {
                reservFenceMaxM = 14398560
            } // 0일때 제한없음 (9999*12시간*60분)
            if ( // 일 범위보다 분 단위가 크면 분으로 세팅 
                reservFence * (60 * 12) <= reservFenceM && // (60 * 12) -> 일을 분으로 비교
                reservFenceMax * (60 * 12) >= reservFenceM
            ) {
                defaultDate = moment(new Date()).format('YYYY-MM-DD HH:mm')
                defaultDate = moment(defaultDate).add(reservFenceM, 'minutes')._d
            }
            if (
                reservFence * 1440 <= reservFenceMaxM &&
                reservFenceMax * 1440 >= reservFenceMaxM
            ) {
                maxDate = moment(new Date()).format('YYYY-MM-DD HH:mm')
                maxDate = moment(maxDate).add(reservFenceMaxM, 'minutes')
                if (maxDate.format('HH:mm') == '00:00') {
                    maxDate.add(-1, 'minutes')
                }
                maxDate = moment(maxDate)._d
            }
        }

        const bookingType = equipOperInfo.FLAG_SELF_USE != 'N' ? 'SU'
                        : equipOperInfo.FLAG_EXPERT == 'Y' ? 'EX'
                        : equipOperInfo.FLAG_REQ != 'N' ? 'RE'
                        : (equipOperInfo.FLAG_WITH_EDU != 'N' && eduList && eduList.length > 0) ? 'WE' 
                        : ''
        //초기값 세팅
        let initData = {
            COMPANY_SKEY        : requesterUserInfo.CDTYPE_SKEY,
            COMPANY_TYPE        : requesterUserInfo.CDTYPE_INOUT ,
            COMPANY_NAME        : requesterUserInfo.CDTYPE_NAME,
            QUENTITY            : equipOperInfo.DEFAULT_QUENTITY,
            REPEAT_COUNT        : equipOperInfo.DEFAULT_REPEAT,
            REPEAT_AREA_COUNT   : equipOperInfo.DEFAULT_AREA_REPEAT,
            BOOKING_TYPE        : bookingType,
            FORM_SKEY           : equipOperInfo.FORM_SKEY,
            FORM_DATA           : '',
            defaultDate,
            maxDate,
            minTimeUnit         : equipOperInfo.MIN_TIME_UNIT || 1,
            maxTimeUnit         : equipOperInfo.MAX_TIME_UNIT || 1,
            timeUnlimit         : equipOperInfo.TIME_UNLIMIT || "N",
            DUPICATE_RESERV_FLAG : equipOperInfo.DUPICATE_RESERV_FLAG || 'N',
            FLAG_NOT_OBSERVER   : equipOperInfo.FLAG_NOT_OBSERVER || 'N',
            FLAG_ALL_AUTH       : equipOperInfo.FLAG_ALL_AUTH || "N",
            FLAG_AUTO_TIME      : equipOperInfo.FLAG_AUTO_TIME || "N",
            FLAG_PREEMPTIVE     : equipOperInfo.FLAG_PREEMPTIVE || "N",
            PREEMPTIVE_TIME     : equipOperInfo.PREEMPTIVE_TIME || 1,
            PREEMPTIVE_SKEY     : equipOperInfo.PREEMPTIVE_SKEY,
            PENALTY_SKEY        : equipOperInfo.PENALTY_SKEY,
            QUENTITY_NAME       : '',
            ATTACH_SKEY         : '',
            UA_EDU_SKEY         : '',
            NOTE                : '',
            OPT_MRO_LIST        : mroOptSubList.map(obj => {
                return {MRO_SKEY: obj.MRO_SKEY, QUENTITY: obj.BASE_QUENTITY}
            }),
            MRO_LIST            : mroSubList.map(obj => {
                return {MRO_SKEY: obj.MRO_SKEY, QUENTITY: obj.BASE_QUENTITY}
            }),
            SEND_TYPE           : 'KAKAO'
        }

        return initData
    }

    const getFristComeExtrStart = (param) => {
        let selectStart = null

        const {
            defaultDate,
            firReservStartDate,
            firReservEndDate,
            timeUnit,
            firRgFlag,
            firOcFlag,
            rgReservType,
            rgAccessFlag,
            rgReservStartSdt,
            rgReservEndSdt,
            ocReservType,
            ocAccessFlag,
            ocReservStartSdt,
            ocReservEndSdt,
        } = param

        //시작일
        if(timeUnit != "1"){
            //정기 예약 지정일
            if(firRgFlag === "Y" && rgReservType === "02") {
                //접속일 기준
                if(rgAccessFlag === "Y") {
                    //예약 시작일이 현재 일보다 전이면 접속일이 시작일
                    if(moment(firReservStartDate)._d < new Date()) { 
                        selectStart = new Date();
                    }
                    //예약 시작일이 현재일보다 후이면 예약시작일이 시작일
                    else { 
                        selectStart = moment(firReservStartDate)._d;
                    }
                }else { 
                    selectStart = moment(firReservStartDate)._d;
                    selectStart.setDate(rgReservStartSdt);
                }
                // while에서 무한로딩 방지
                selectStart.setMinutes(0)
            } 
            //수시 예약 지정일
            else if(firOcFlag == "Y" && ocReservType == "02") { 
                //접속일 기준
                if(ocAccessFlag == "Y") {
                    //예약 시작일이 현재 일보다 전이면 접속일이 시작일
                    if(moment(firReservStartDate)._d < new Date()) { 
                        selectStart = new Date();
                    }
                    //예약 시작일이 현재일보다 후이면 예약시작일이 시작일
                    else { 
                        selectStart = moment(firReservStartDate)._d;
                    }
                }else {
                    selectStart = new Date();
                    
                    if(new Date() < moment(firReservStartDate)._d ) {
                        selectStart = moment(firReservStartDate)._d;
                    }
                    selectStart.setDate(rgReservStartSdt);
                }
            }
            
	    }else {
            const today = moment(new Date()).format("YYYY-MM-DD")
            
            //정기 예약 지정일
            if(firRgFlag === "Y" && rgReservType === "02") {
                //접속일 기준
                if(rgAccessFlag == "Y") {
                    //예약 시작일이 현재일보다 후이면 예약시작일이 시작일
                    if(moment(firReservStartDate)._d > moment(today)._d) { 
                        selectStart = moment(firReservStartDate)._d;
                    }
                    //예약 시작일이 현재 일보다 전이면 접속일이 시작일
                    else { 
                        selectStart = moment(today)._d;
                    }
                }else { 
                    //현재 보고있는 달에서 시작점 체크
                    if(moment(firReservStartDate)._d > moment(defaultDate)._d) { 
                        selectStart = moment(firReservStartDate)._d;
                    }else {
                        selectStart = moment(defaultDate)._d;
                    }
                    selectStart.setDate(rgReservStartSdt);
                }
            } 
            //수시 예약 지정일
            else if(firOcFlag == "Y" && ocReservType == "02") { 
                //접속일 기준
                if(ocAccessFlag == "Y") {
                    //예약 시작일이 현재 일보다 전이면 접속일이 시작일
                    if(moment(firReservStartDate)._d < moment(today)._d) { 
                        selectStart = moment(today)._d
                    }
                    //예약 시작일이 현재일보다 후이면 예약시작일이 시작일
                    else { 
                        selectStart = moment(firReservStartDate,"YYYY-MM-DD")._d
                    }
                }else {
                    //현재 보고있는 달에서 시작점 체크
                    if(moment(firReservStartDate)._d > moment(defaultDate)._d) { 
                        selectStart = moment(firReservStartDate)._d
                    }else {
                        selectStart = moment(defaultDate)._d
                    }
                    selectStart.setDate(rgReservStartSdt);
                }
            }
	    }

        return selectStart
    }

    const getFirstComeExtrEnd = (selectStart, param) => {
        let selectEnd = null
        
        const {
            firReservEndDate,
            timeUnit,
            firRgFlag,
            firOcFlag,
            rgReservType,
            rgReservEndSdt,
            ocReservType,
            ocReservEndSdt,
        } = param   

        if(timeUnit != "1"){
            //정기 예약 지정일
            if(firRgFlag === "Y" && rgReservType === "02") {
                //예약종료일 월말
                if(rgReservEndSdt == "ML") {
                    selectEnd = moment(moment(selectStart).format('YYYY-MM-01')).add(1, 'months')._d
                    
                    if(moment(firReservEndDate)._d < selectEnd){
                        selectEnd = moment(firReservEndDate)._d
                    }
                }else { //예약종료일 분기말
                    selectEnd = moment(firReservEndDate)._d
                }
            } 
            //수시 예약 지정일
            else if(firOcFlag === "Y" && ocReservType === "02") { 
                //예약종료일 월말
                if(ocReservEndSdt == "ML") { 
                    selectEnd = moment(moment(selectStart).format('YYYY-MM-01')).add(1, 'months')._d
                    
                    if(moment(firReservEndDate)._d < selectEnd){
                        selectEnd = moment(firReservEndDate)._d
                    }
                }else { //예약종료일 분기말
                    selectEnd = moment(firReservEndDate)._d
                }
            }
            
        }else {
            //정기 예약 지정일
            if(firRgFlag === "Y" && rgReservType === "02") {
                //예약종료일 월말
                if(rgReservEndSdt == "ML") { 
                    selectEnd = moment(selectStart).add(1, 'months')._d
                    selectEnd.setDate(0);
                    
                    if(moment(firReservEndDate)._d < selectEnd){
                        if(moment(firReservEndDate).format('HH:mm') == '00:00') {
                            selectEnd = moment(firReservEndDate).add(-1, 'days')._d
                        }else {
                            selectEnd = moment(firReservEndDate)._d
                        }
                    }
                }else { //예약종료일 분기말
                    if(moment(firReservEndDate).format('HH:mm') == '00:00') {
                        selectEnd = moment(firReservEndDate).add(-1, 'days')._d
                    }else {
                        selectEnd = moment(firReservEndDate)._d
                    }
                }
            } 
            //수시 예약 지정일
            else if(firOcFlag === "Y" && ocReservType === "02") { 
                
                //예약종료일 월말
                if(ocReservEndSdt == "ML") {
                    selectEnd = moment(selectStart).add(1, 'months')._d
                    selectEnd.setDate(0);
                    if(moment(firReservEndDate)._d < selectEnd){
                        selectEnd = moment(firReservEndDate).add(-1, 'days')._d
                    }
                }else { //예약종료일 분기말
                    selectEnd = moment(firReservEndDate).add(-1, 'days')._d
                }
                
            }
        }

        return selectEnd
    }
    
    const checkSelectStart = async (selectStart, reservData) => {
        const {
            equipMstr,
            requesterUserInfo,
            equipOperInfo,
        } = reservData

        const param = {
            EQUIP_SKEY  : equipMstr.EQUIP_SKEY,
            OPER_SKEY   : equipOperInfo.OPER_SKEY,
            START_DT_STR: moment(selectStart).format('YYYY-MM-DD'),
            END_DT_STR  : moment(selectStart).add(1, 'days').format('YYYY-MM-DD'),
            AUTH_TYPE   : requesterUserInfo.AUTH_TYPE,
            lang        : 'ko'
        }

        return await tremApi("/r/hm/equipReservation/reservation/calendar/notHoliday", param).then(data => {
            return moment(data)._d
        }).catch(err => {
            alert(G.t('trem.lang.home.0836')+'2', err)/* 오류발생2 */
        })
    }

    //값 변경
    const handleChangeData = (e, i) => {
        const param = { ...paramData }
        if(e.target.type === 'checkbox') {
            e.target.checked 
            ? param[e.target.name] = "Y"
            : param[e.target.name] = "N"
        }else if(e.target.className === 'OPT_MRO_LIST') {
            let OPT_MRO_LIST = paramData.OPT_MRO_LIST
            OPT_MRO_LIST[i].QUENTITY = e.target.value
            param['OPT_MRO_LIST'] = OPT_MRO_LIST
        }else if(e.target.className === 'MRO_LIST') {
            let MRO_LIST = paramData.MRO_LIST
            MRO_LIST[i].QUENTITY = e.target.value
            param['MRO_LIST'] = MRO_LIST
        }else {
            param[e.target.name] = e.target.value
            if (e.target.name === 'BOOKING_TYPE') {
                e.target.value != 'WE' && e.target.value != 'WU'
                    ? (param['UA_EDU_SKEY'] = '')
                    : e.target.value != 'EX'
                    ? (param['EXPERT_SKEY'] = '')
                    : null
                setTempDate(null)
                setCalendarEvents(paramData.defaultDate, e.target.value)
            }
        }
        setDataStore({ ...dataStore, paramData: param })
        setPickerDate(paramData.defaultDate)


    }

    //예약신청
    const requestReservation = async () => {
        if(reservValidate()) {
            
            //예약 신청시에만 확인
            if(equipOperInfo.FLAG_ATTACH_FILE==="Y"){ // 첨부파일 필수 체크시
                if(attachFileInfo.fileList.length <= 0) {
                    alert(G.t('trem.lang.home.1041'))  // 첨부파일을 업로드 해주세요.
                    return false
                }
            }

            if(equipMstr.FIR_CM_SCH_SKEY && paramData.FLAG_AUTO_TIME != "Y") {
                const startDt = startDate ? moment(startDate).format("YYYY-MM-DD HH:mm") : ''
                const endDt = !endDate ? ''
                            : equipOperInfo.TIME_UNIT == '1'
                            ? moment(endDate).format("YYYY-MM-DD 23:59")
                            : moment(endDate).format("YYYY-MM-DD HH:mm")
                
                let first_check_param = {
                    FIR_CM_SCH_SKEY	: equipMstr.FIR_CM_SCH_SKEY,
                    EQUIP_SKEY      : equipMstr.EQUIP_SKEY,
                    RES_START_DT_STR: startDt,
                    RES_END_DT_STR  : endDt,
                    TIME_UNIT       : equipOperInfo.TIME_UNIT,
                    USER_SKEY       : requesterUserInfo.USER_SKEY,
                }

                const firstCheckData = await tremApi("/equipFirstCome/hm/reservation/check/json", nullCheckParameter(first_check_param))
                
                if(firstCheckData.RESULT_CODE === 'SUCCESS') {
                    setNoticeData({
                        noticeFlag : false
                    })
                }else {
                    // 신청 기간 아닐 때
					let msg = G.t('trem.lang.home.0728')+" : " + firstCheckData.SCH_START_DT_STR + " ~ " + firstCheckData.SCH_END_DT_STR; // 신청 가능 기간 : ~
					// 예약 기간 아닐 때
					if(firstCheckData.RESULT_CODE == "ER_04"){
						msg = G.t('trem.lang.home.0729')+" : " + firstCheckData.RESERV_START_DT_STR + " ~ " + firstCheckData.RESERV_END_DT_STR; // 예약 가능 기간 : ~
					}else if(firstCheckData.RESULT_CODE == "ER_02"){
						msg = G.t('trem.lang.home.0704') //예약 인원 초과
					}

                    setNoticeData({
                        noticeFlag : true,
                        noticeMsg : msg
                    })
                    alert(firstCheckData.RESULT_MSG)
                    return false
                }
            }
            
            
            const startDtStr = startDate ? moment(startDate).format("YYYY-MM-DD HH:mm") : ''
            const endDtStr = !endDate ? ''
                            : equipOperInfo.TIME_UNIT == '1'
                            ? moment(endDate).add(1, "days").format("YYYY-MM-DD HH:mm")
                            : moment(endDate).format("YYYY-MM-DD HH:mm")
            let check_param = {
                EQUIP_SKEY      : equipMstr.EQUIP_SKEY,
                OPER_SKEY       : equipOperInfo.OPER_SKEY,
                DUPICATE_RESERV_FLAG: paramData.DUPICATE_RESERV_FLAG,
                AUTH_TYPE       : requesterUserInfo.AUTH_TYPE,
                BOOKING_TYPE    : paramData.FLAG_AUTO_TIME === "Y" ? 'RE' : paramData.BOOKING_TYPE,
                START_DT_STR    : startDtStr,
                END_DT_STR      : endDtStr,
                FLAG_NOT_OBSERVER: paramData.FLAG_NOT_OBSERVER,
                FLAG_ALL_AUTH   : paramData.FLAG_ALL_AUTH,
                SCHED_KIND      : equipOperInfo.SCHED_KIND,
                FLAG_AUTO_TIME  : paramData.FLAG_AUTO_TIME,
                managerFlag     : managerFlag,
                RECESS_FLAG     : equipOperInfo.RECESS_FLAG,
                TIME_UNIT       : equipOperInfo.TIME_UNIT,
                lang            : 'ko',
                //선착순
                FIR_CM_SCH_SKEY	: equipMstr.FIR_CM_SCH_SKEY,
                FIR_RG_FLAG		: equipMstr.FIR_RG_FLAG, //정기예약여부
                RG_RESERV_TYPE	: equipMstr.RG_RESERV_TYPE, //정기유형
                FIR_OC_FLAG		: equipMstr.FIR_OC_FLAG, //수시예약여부
                OC_RESERV_TYPE	: equipMstr.OC_RESERV_TYPE, //수시유형
            }

            const checkData = await tremApi('/r/hm/equipReservation/reservation/calendar/check', nullCheckParameter(check_param)).then(data => {
                return data
            }).catch(err => {
                alert(G.t('trem.lang.home.0836')+'3', err)/* 오류발생3 */
            })
            if(checkData && checkData > 0 && (equipOperInfo?.CHARGE_TYPE !="05" && equipOperInfo?.CHARGE_TYPE !="06")) {
                alert(G.t('trem.lang.home.0730')) //선택하신 시간에 다른 일정이 존재합니다.
            } else {
                const formData = formRef.current ? getFormData(formRef.current) : ''

                let param = {
                    EQUIP_SKEY 		    : equipMstr.EQUIP_SKEY,
                    OPER_SKEY 		    : equipOperInfo.OPER_SKEY,
                    REQUESTER_SKEY	    : requesterUserInfo.USER_SKEY,
                    REQUESTER_AUTH      : requesterUserInfo.AUTH_TYPE,
                    REQUESTER_EMP_NO    : requesterUserInfo.BSIN_EMP_NO,
                    COMPANY_SKEY        : paramData.COMPANY_SKEY,
                    COMPANY_TYPE        : paramData.COMPANY_TYPE,
                    FORM_SKEY           : equipOperInfo.FORM_SKEY,
                    FORM_DATA           : formData,
                    START_DT_STR        : startDtStr,
                    END_DT_STR          : endDtStr,
                    REPEAT_AREA_COUNT   : spChkData.length,
                    REPEAT_COUNT        : paramData.REPEAT_COUNT,
                    QUENTITY            : paramData.QUENTITY,
                    QUENTITY_NAME       : paramData.QUENTITY_NAME,
                    BOOKING_TYPE        : paramData.BOOKING_TYPE,
                    UA_EDU_SKEY         : paramData.UA_EDU_SKEY,
                    FLAG_AUTO_TIME      : paramData.FLAG_AUTO_TIME,
                    NOTE                : paramData.NOTE,
                    PREEMPTIVE_SKEY     : paramData.PREEMPTIVE_SKEY,
                    PENALTY_SKEY        : paramData.PENALTY_SKEY,
                    ATTACH_SKEY         : attachFileInfo.ATTACH_SKEY || '',
                    FIR_CM_SCH_SKEY     : equipMstr.FIR_CM_SCH_SKEY,
                }
                param['STATUS'] = paramData.BOOKING_TYPE === 'EX' ? 'AW' : 'AP'
                if(paramData.BOOKING_TYPE === 'EX') {
                    param['EXPERT_TYPE'] = paramData.EXPERT_TYPE
                    param['EXPERT_SKEY'] = paramData.EXPERT_SKEY
                }
                paramData.OPT_MRO_LIST.map((obj, index) => {
                    param[`OPT_MRO_LIST[${index}].MRO_SKEY`] = obj.MRO_SKEY
                    param[`OPT_MRO_LIST[${index}].QUENTITY`] = obj.QUENTITY
                })
                paramData.MRO_LIST.map((obj, index) => {
                    param[`MRO_LIST[${index}].MRO_SKEY`] = obj.MRO_SKEY
                    param[`MRO_LIST[${index}].QUENTITY`] = obj.QUENTITY
                })
            
                const reservSaveParam = await tremApi('/r/hm/equipReservation/reservation/getData', nullCheckParameter(param)).then(data => {
                    return data
                }).catch(err =>{
                    alert(G.t('trem.lang.home.0836')+'4', err)/* 오류발생4 */
                })
                if(reservSaveParam) {
                    // reservSaveParam
                    reservPopupProps.setOpen(true, reservSaveParam)
                    
                }
            }
        }
    }

    //선점예약 확정
    const preemptiveSave = async () => {
        if(reservValidate()) {
            const startDtStr = startDate ? moment(startDate).format("YYYY-MM-DD HH:mm") : ''
            const endDtStr = !endDate ? ''
                            : equipOperInfo.TIME_UNIT == '1'
                            ? moment(endDate).add(1, "days").format("YYYY-MM-DD HH:mm")
                            : moment(endDate).format("YYYY-MM-DD HH:mm")

            let check_param = {
                EQUIP_SKEY      : equipMstr.EQUIP_SKEY,
                OPER_SKEY       : equipOperInfo.OPER_SKEY,
                DUPICATE_RESERV_FLAG: paramData.DUPICATE_RESERV_FLAG,
                AUTH_TYPE       : requesterUserInfo.AUTH_TYPE,
                BOOKING_TYPE    : paramData.FLAG_AUTO_TIME === "Y" ? 'RE' : paramData.BOOKING_TYPE,
                START_DT_STR    : startDtStr,
                END_DT_STR      : endDtStr,
                FLAG_NOT_OBSERVER: paramData.FLAG_NOT_OBSERVER,
                FLAG_ALL_AUTH   : paramData.FLAG_ALL_AUTH,
                SCHED_KIND      : equipOperInfo.SCHED_KIND,
                FLAG_AUTO_TIME  : paramData.FLAG_AUTO_TIME,
                managerFlag     : managerFlag,
                RECESS_FLAG     : equipOperInfo.RECESS_FLAG,
                TIME_UNIT       : equipOperInfo.TIME_UNIT,
                lang            : 'ko',
                //선착순
                FIR_CM_SCH_SKEY	: equipMstr.FIR_CM_SCH_SKEY,
                FIR_RG_FLAG		: equipMstr.FIR_RG_FLAG, //정기예약여부
                RG_RESERV_TYPE	: equipMstr.RG_RESERV_TYPE, //정기유형
                FIR_OC_FLAG		: equipMstr.FIR_OC_FLAG, //수시예약여부
                OC_RESERV_TYPE	: equipMstr.OC_RESERV_TYPE, //수시유형
            }

            const checkData = await tremApi('/r/hm/equipReservation/reservation/calendar/check', nullCheckParameter(check_param)).then(data => {
                return data
            }).catch(err => {
                alert(G.t('trem.lang.home.0836')+'3', err)/* 오류발생3 */
            })

            if(checkData && checkData > 0 && (equipOperInfo?.CHARGE_TYPE !="05" && equipOperInfo?.CHARGE_TYPE !="06")) { //equipOperSpList.length === 0
                alert(G.t('trem.lang.home.0730')) //선택하신 시간에 다른 일정이 존재합니다.
            } else {
                G.confirm(G.t('trem.lang.home.0731')).then(async success => { //예약 시간을 확정하시겠습니까?
                    if(success) {
                        let preemptiveSaveParam = {
                            EQUIP_SKEY: equipMstr.EQUIP_SKEY,
                            START_DT_STR: startDtStr,
                            END_DT_STR: endDtStr,
                            PREEMPTIVE_TIME: paramData.PREEMPTIVE_TIME
                        }

                        const preemptiveData = await tremApi("/r/hm/equipReservation/reservation/preemptive/insert"
                        , nullCheckParameter(preemptiveSaveParam)).then(data => {
                            return data
                        }).catch(err => {
                            alert(G.t('trem.lang.home.0836')+"6")/* 오류발생6 */
                        })

                        if(preemptiveData) {
                            setDataStore({...dataStore, paramData: {...paramData, PREEMPTIVE_SKEY: preemptiveData.PREEMPTIVE_SKEY, PT_END_DT: preemptiveData.PT_END_DT}})
                            
                        }
                    }
                })
            }
        }
    }

    //선점예약 취소
    const preemptiveCancel = () => {
        G.confirm(G.t('trem.lang.home.0732')).then(async success => { //확정 시간을 취소하시겠습니까?
            if(success) {
                const preemptiveSkey = await tremApi("/r/hm/equipReservation/reservation/preemptive/delete"
                , {PREEMPTIVE_SKEY: paramData.PREEMPTIVE_SKEY}).then(data => {
                    return data
                }).catch(err => {
                    alert(G.t('trem.lang.home.0836')+"7", err)/* 오류발생7 */
                })

                if(preemptiveSkey) {
                    alert(G.t('trem.lang.home.0733')) //확정 시간이 취소되었습니다.
                    
                    setDataStore({...dataStore, paramData: {...paramData, PREEMPTIVE_SKEY: null, PT_END_DT: null}})
                            
                    setRangeDate({startDate: null, endDate: null})
                    
                }
            }
        })
    }

    //BOOING_TYPE radio button
    const InputBookingType = props => {
        const {index, val, nm} = props

        return (
            <div onClick={G.radioHandleClick} tabIndex={0} aria-checked={val === paramData.BOOKING_TYPE} role="radio" onKeyPress = {(e)=>{handleKeyPress(e, handleChangeData)}}>
                <input type="radio" title="예약옵션 선택" value={val} id={"BOOKING_TYPE_"+val} name="BOOKING_TYPE" checked={val === paramData.BOOKING_TYPE} onChange={handleChangeData} />
                <label htmlFor={"BOOKING_TYPE_"+val }>{nm}</label>
            </div>
      )
    }

    /*특수예약*/
    //선택 구간
    const [spChkData, setSpChkData] = useState([])
    //기존 선택 구간
    const [spPrechkList, setSpPrechkList] = useState([])
    const setEquipSpecial = (startDate, endDate, reservData) => {
            tremApi(
            "/r/hm/equipReservation/reservation/special",
            {
                EQUIP_SKEY: reservData.equipMstr?.EQUIP_SKEY,
                OPER_SKEY: reservData.equipOperInfo?.OPER_SKEY,
                START_DT_STR: moment(startDate).format('YYYY-MM-DD HH:mm'),
                END_DT_STR: moment(endDate).format('YYYY-MM-DD HH:mm'),
            }
        ).then(data => {
            setSpPrechkList(data)
            setSpChkData([])
            document.querySelectorAll(".chk").forEach(function(v, i) {
                v.checked = false;
            });
        })
    }

    /***************Popup******************/
    /**** 예약자 변경 popup -start****/
    //예약자 변경
    const userPopupProps = usePopup('trem.lang.home.0734') //예약자 선택
    const [usePopupVal, setUsePopupVal] = useState({})

    const getUsePopupValue = obj =>{
        setUsePopupVal(obj)
    }

    const useButtons = [
        {
            title: G.t('trem.lang.home.0200'),/* 선택 */
            className: 'red',
            handler: () => {
                if(!usePopupVal.NAME) {
                    alert(G.t('trem.lang.home.0735')) /* 선택되지 않았습니다. */
                    return false
                }
                const userSkey = usePopupVal.USER_SKEY
                getReservDetail(userSkey, equipMstr.EQUIP_SKEY, equipOperInfo.OPER_SKEY, equipMstr.FIR_CM_SCH_SKEY)
                
                userPopupProps.handleClose()
            }
        },
        {
            title: G.t('trem.lang.home.0146'),/* 닫기 */
            handler: ()=>{
                userPopupProps.handleClose()
            }
        }
    ]

    /**** 예약자 변경 popup -end****/

    //소속(부서)변경
    const deptPopupProps = usePopup('trem.lang.home.0736') //거래처 선택
    const DeptPopup = popupProps => {
        const {open, handleClose} = popupProps
        
        let popupVal = {}

        const buttons = [
            {
                title: G.t('trem.lang.home.0200'),/* 선택 */
                className: 'red',
                handler: () => {
                    if(!popupVal.MASTER_SKEY) {
                        alert(G.t('trem.lang.home.0735')) /* 선택되지 않았습니다. */
                        return false
                    }
                    setDataStore({...dataStore, 
                        paramData: {
                            ...paramData, 
                            COMPANY_SKEY: popupVal.MASTER_SKEY,
                            COMPANY_TYPE: popupVal.MASTER_TYPE, 
                            COMPANY_NAME: popupVal.MASTER_NAME
                        }
                    })

                    handleClose()
                }
            },
            {
                title: G.t('trem.lang.home.0146'),/* 닫기 */
                handler: handleClose
            }
        ]

        const getPopupValue = obj =>{
            popupVal = obj
        }

        return (
            open && (
                <ModalBox {...popupProps} buttons={buttons}>
                    <PopupDeptSelect popupTitle = "client" getPopupValue={getPopupValue}/>
                </ModalBox>
            )
        )
    }

    //BOOKING_TYPE:EX, 전문가 선택
    const expertPopupProps = usePopup('trem.lang.home.0737') //전문가 선택
    const expertButtons = [
        {
            title: G.t('trem.lang.home.0200'),/* 선택 */
            className: 'red',
            handler: (popupData) => {
                setDataStore({...dataStore, paramData: {...paramData, EXPERT_SKEY: popupData?.EXPERT_SKEY, EXPERT_NAME: popupData?.NAME_KOR}})
                expertPopupProps?.handleClose()
            }
        },
        {
            title: G.t('trem.lang.home.0146'),/* 닫기 */
            handler: expertPopupProps?.handleClose
        }
    ]

    //장비예약 요약 팝업
    const reservPopupProps = usePopup('trem.lang.home.0010')/* 장비예약 */
    const reservChargeProps = {
        reservPopupProps,
        equipOperSpList,
        spChkData,
    }

    //소속정보 입력 팝업
    const companyCheckPopupProps = usePopup('알림')
    const companyCheckPopupButtons = [
       {
           title:'등록하기',
           handler:()=>{
               G.gotoPage("/home/collabi/myPage/user/info")
           }
       }
    ]

    const reservValidate = () => {
        if(!requesterUserInfo.USER_SKEY) {
            alert(G.t('trem.lang.home.0738')) //예약자 정보가 없어 예약할수 없습니다.
            return false
        }

        if(!paramData.COMPANY_SKEY) {
           // alert(G.t('trem.lang.home.0739')) //계산서 정보가 없어 예약할수 없습니다.
           companyCheckPopupProps.setOpen(true)
            return false
        }

        if(paramData.FLAG_AUTO_TIME != "Y") {
            if(!paramData.BOOKING_TYPE) {
                alert(G.t('trem.lang.home.0740')) //예약방법을 선택해주세요.
                return false
            }else {
                if((paramData.BOOKING_TYPE === 'WE' || paramData.BOOKING_TYPE === 'WU')
                && !paramData.UA_EDU_SKEY) {
                    alert(G.t('trem.lang.home.0741')) //병행 교육을 선택해주세요.
                    return false
                }
            }

            if(!startDate) {
                alert(G.t('trem.lang.home.0742')) //시작시간을 선택해주세요.
                startDateRef.current.focus()
                return false
            }

            if(!endDate) {
                alert(G.t('trem.lang.home.0743')) //종료시간을 선택해주세요.
                return false
            }
            
            if(moment(endDate).diff(startDate, "minutes", true) < 0) {
                alert(G.t('trem.lang.home.0744')) // 예약 시작시간이 종료시간보다 클수 없습니다.
                return false
            }


            //선착순 자동지정 사용하지 않을때만
            if(equipMstr.USE_OPT_FLAG != "Y" 
                || !((equipMstr.FIR_RG_FLAG == "Y" && equipMstr.RG_RESERV_TYPE == "02") 
                || (equipMstr.FIR_OC_FLAG == "Y" && equipMstr.OC_RESERV_TYPE == "02"))) {
                if(equipOperInfo.TIME_UNIT == "1"){
                    var diffDt = moment(endDate).diff(startDate, "days", true) + 1
                    
                    if(paramData.minTimeUnit > diffDt){
                        alert(G.t('trem.lang.home.0746')+paramData.minTimeUnit+G.t('trem.lang.home.0545')+G.t('trem.lang.home.0705'))/* 최소 예약시간은 ~ 일입니다.  */ 
                        return false
                    }
                    else if(paramData.maxTimeUnit < diffDt){
                        if(paramData.timeUnlimit != 'Y') {
                            alert(G.t('trem.lang.home.0747')+paramData.maxTimeUnit+G.t('trem.lang.home.0545')+G.t('trem.lang.home.0705'))/* 최대 예약시간은 ~ 일입니다. */
                            return false	
                        }
                    }
                }
                else{
                    var diffDt = moment(endDate).diff(startDate, "minutes");
                    
                    if((equipOperInfo.TIME_UNIT * paramData.minTimeUnit) > diffDt){
                        alert(G.t('trem.lang.home.0746')+(equipOperInfo.TIME_UNIT * paramData.minTimeUnit)+G.t('trem.lang.home.0706')+G.t('trem.lang.home.0705')) /* 최소 예약시간은 ~ 분입니다. */
                        return false		
                    }
                    else if((equipOperInfo.TIME_UNIT * paramData.maxTimeUnit) < diffDt){
                        if(paramData.timeUnlimit != 'Y') {
                            alert(G.t('trem.lang.home.0747')+(equipOperInfo.TIME_UNIT * paramData.maxTimeUnit)+G.t('trem.lang.home.0706')+G.t('trem.lang.home.0705')) /* 최대 예약시간은 ~ 분입니다. */
                            return false
                        }
                    }
                    
                    if(equipOperInfo.TIME_UNIT == "60" && diffDt%60 > 0){
                        alert(G.t('trem.lang.home.0062')+" 60"+G.t('trem.lang.home.0706')+G.t('trem.lang.home.0705'))
                        /* 예약시간 단위는 60분입니다 */
                        return false
                    }
                }			
            }
            
            if(equipOperSpList && equipOperSpList.length > 0) {
                if(spChkData.length < 1) {
                    alert(G.t('trem.lang.home.0745')) //장비의 구간을 하나 이상 선택해주세요.
                    return false
                }
            }

        }

        return true
    }

   
    /*******************************************************************
     * Calendar & DatePicker
     * *****************************************************************/
    //DatePicker
    const [rangeDate, setRangeDate] = useState({startDate: null, endDate: null})
    
    const {startDate, endDate} = rangeDate
    const customInputRef = createRef()
    const calendar = useRef([])
    const CustomInput = forwardRef(({ value, onClick, title, id }, ref ) => {
        return(
        <label>
            <input 
                id ={id} 
                title={title} 
                type="text" 
                value={value} 
                onClick={onClick} 
                ref={el => (
                    id ==="dpStartDt"
                    ?calendar.current[0] = el
                    :calendar.current[1] = el
                )} 
                style={{backgroundColor: "white", cursor: "pointer"}} 
                readOnly 
            />
            <a ref={id === "dpStartDt" ? startDateRef : null} href="javascript:void(0);" onClick={onClick} className="btn_cal" >달력</a>
        </label>
        )
    })

     //시간 커스텀
     const timeIntervals = equipOperInfo?.TIME_UNIT
     const defautMoment = !R.isNil(timeIntervals) ? timeIntervals*1 : 60
     
     const rendering = () => {
         const result = [];
         for (let i = 0; i < 1440; (i+=defautMoment)) {
             const hour = i/60 < 10 ? '0'+Math.floor(i/60) : Math.floor(i/60) 
             const minute = i%60 < 10 ? '0'+i%60 : i%60
             const time = hour+':'+minute
         result.push(<option title={time} value={time} key={time}>{time}</option>)
         }
         return result;
     }
     const CustomTimeInput = forwardRef(({ value, onChange , title, id }, ref ) => {
        const ariaLabel =  `${(id=='dpStartDt_t'? G.t('trem.lang.home.0748') : G.t('trem.lang.home.0749'))}
            ${G.t('trem.lang.home.1253')} 
            ${value} ${(value ? G.t('trem.lang.home.1251'):'')}
            ${(id=='dpStartDt_t'? calendar.current[0].value : calendar.current[1].value)}`
         return(
            <select
                title={(id=='dpStartDt_t'? G.t('trem.lang.home.0748') : G.t('trem.lang.home.0749'))+G.t('trem.lang.home.1253') +  G.t('trem.lang.home.0241')}
                role="listbox"
                id={id}
                value={value||"00:00"}
                aria-label={ariaLabel}
                onChange={(e) => {
                    onChange(e.target.value)
                }}
                style={{ border: "solid 1px #e2e2e2", width: '150px' }}
            >  
                { rendering()}
            </select>
         )
     })

    //DatePicker Day
    const DatePickerComponentDay = () => {
        const [selectRangeDate, setSelectRangeDate] = useState({selectStart: startDate, selectEnd: endDate})
        const {selectStart, selectEnd} = selectRangeDate
        const changeStartDate = (selectStart) => {

            if( !checkCurrentTime(selectStart)){
                return 
            }

            const selectEnd = moment(selectStart).add(equipOperInfo.TIME_UNIT, 'minutes')._d
            setSelectRangeDate({selectStart, selectEnd})
            //calendar.current[0].focus();
        }
        const changeEndDate =(selectEnd) => {
            if( !checkCurrentEndTime(selectEnd)){
                return 
            }

            setSelectRangeDate({...selectRangeDate, selectEnd})
            //calendar.current[1].focus();
        }

        const closeDatePicker = () => {
            let useTime = moment(selectEnd).diff(selectStart, "hours", true)
                useTime = Math.round(useTime*100)/100
            setDataStore({...dataStore, paramData:{...paramData, USE_TIME: useTime}})
            setRangeDate({startDate: selectStart, endDate: selectEnd})
            // setCalendarEvents(selectStart)
            
            
            setPickerDate(selectEnd)
        }
        const disabled = equipMstr.USE_OPT_FLAG === "Y" 
                    && ((equipMstr.FIR_RG_FLAG == "Y" && equipMstr.RG_RESERV_TYPE == "02") 
                    || (equipMstr.FIR_OC_FLAG == "Y" && equipMstr.OC_RESERV_TYPE == "02"))
                    || (paramData?.PT_END_DT && moment(paramData.PT_END_DT).diff(Date.now(), "milliseconds", true) > 0 )
        return <Fragment>
            <div className="cal_box2">
                <label>{G.t('trem.lang.home.0748')}</label> {/* 시작 */}
                <DatePicker
                    title="신청 시작일자"
                    id = "dpStartDt"
                    locale={ko}
                    selected={selectStart}
                    startDate={selectStart}
                    minDate={paramData.defaultDate}
                    maxDate={paramData.maxDate}
                    dateFormat="yyyy-MM-dd HH:mm"
                    shouldCloseOnSelect={false}
                    onChange={changeStartDate}
                    onCalendarClose={closeDatePicker}
                    customInput={<CustomInput/>}
                    showTimeInput
                    timeInputLabel={G.t('trem.lang.home.0748')+G.t('trem.lang.home.1253')}
                    customTimeInput={<CustomTimeInput id="dpStartDt_t"/>}
                    timeFormat="HH:mm"
                    disabled={disabled}
                />
            </div>
            <div className="cal_box2">  
                <span>~ {G.t('trem.lang.home.0749')}</span> {/* 종료 */}
                <DatePicker
                    title="신청 종료일자"
                    id = "dpEndDt"
                    locale={ko}
                    selected={selectEnd}
                    startDate={selectEnd}
                    minDate={selectEnd}
                    maxDate={paramData.maxDate}
                    dateFormat="yyyy-MM-dd HH:mm"
                    shouldCloseOnSelect={false}
                    onChange={changeEndDate}
                    onCalendarClose={closeDatePicker}
                    customInput={<CustomInput />}
                    showTimeInput
                    timeInputLabel={G.t('trem.lang.home.0749')+G.t('trem.lang.home.1253')}
                    customTimeInput={<CustomTimeInput id="dpEndDt_t"/>}
                    timeFormat="HH:mm"
                    filterTime={time => {
                        return selectStart < time
                    }}
                    disabled={disabled}
                />
            </div>
        </Fragment>
    }
    //DatePicker Month
    const DatePickerComponentMonth = () => {
        const [selectRangeDate, setSelectRangeDate] = useState({selectStart: startDate, selectEnd: endDate})
        const {selectStart, selectEnd} = selectRangeDate
        
        const changeStartDate = (selectStart) => {
            setSelectRangeDate({selectStart, selectEnd: selectStart})
            calendar.current[0].focus()
        }
        const changeEndDate =(selectEnd) => {
            setSelectRangeDate({...selectRangeDate, selectEnd})
            calendar.current[1].focus()
        }
        const closeDatePicker = () => {
            setRangeDate({startDate: selectStart, endDate: selectEnd})

            // 주석처리 웹 접근성 
            //setSelectCalendarEvent(selectStart, selectEnd, calEventSource, reservData)
            //setCalendarEvents(selectStart)
            //setCalendarEvents(startDt)
            //setPickerDate(selectEnd)
        }

        const disabled = equipMstr.USE_OPT_FLAG === "Y" 
                    && ((equipMstr.FIR_RG_FLAG == "Y" && equipMstr.RG_RESERV_TYPE == "02") 
                    || (equipMstr.FIR_OC_FLAG == "Y" && equipMstr.OC_RESERV_TYPE == "02"))
                    || (paramData?.PT_END_DT && moment(paramData.PT_END_DT).diff(Date.now(), "milliseconds", true) > 0 )
        return <Fragment>
            <label>{G.t('trem.lang.home.0091')}</label>{/* 시작 */}
            <DatePicker
                title="신청 시작일자"
                id = "dpStartDt"
                locale={ko}
                selected={selectStart}
                startDate={selectStart}
                minDate={paramData.defaultDate}
                maxDate={paramData.maxDate}
                dateFormat="yyyy-MM-dd"
                shouldCloseOnSelect={false}
                onChange={changeStartDate}
                onCalendarClose={closeDatePicker}
                customInput={<CustomInput />}
                disabled={disabled}
            />
            <span>~ {G.t('trem.lang.home.0749')}</span> {/* 종료 */}
            <DatePicker
                title="신청 종료일자"
                id = "dpEndDt"
                locale={ko}
                selected={selectEnd}
                startDate={selectEnd}
                minDate={selectStart}
                maxDate={paramData.maxDate}
                dateFormat="yyyy-MM-dd"
                shouldCloseOnSelect={false}
                onChange={changeEndDate}
                onCalendarClose={closeDatePicker}
                customInput={<CustomInput />}
                disabled={disabled}
            />
        </Fragment>
    }

    //FullCalendar DatePicker Day
    const [pickerDate, setPickerDate] = useState(paramData.defaultDate)
   
    const DatePickerComponentDate = () => {
        
        const changePickerDate = selectDate => {
            setPickerDate(selectDate)
            //해당 날짜 이벤트 가져오기
            setCalendarEvents(selectDate)
            
        }
        return (
            <div className="d_datepicker_wrap" style={{marginTop: "60px"}}>
                <DatePicker
                    locale={ko}
                    selected={pickerDate}
                    minDate={paramData.defaultDate}
                    maxDate={paramData.maxDate}
                    onChange={changePickerDate}
                    inline
                    renderCustomHeader={({
                        date,
                        decreaseMonth,
                        increaseMonth,
                        prevMonthButtonDisabled,
                        nextMonthButtonDisabled
                    })=>(
                     <div className="date-customheader flex flex-row justify-center gap-10" >
                        {
                            date > new Date() === true// 선택한 월이 현재시각보다 클때 보임                   
                            &&<buttion title = "이전" onClick={decreaseMonth} disabled = {prevMonthButtonDisabled}>
                                <FontAwesomeIcon icon={faAngleLeft} style={{fontSize:"12px"}} size="2x"/>  {/* <i className="icon-arrow-left32"/> */}
                            </buttion>
                        } 
                        <div className="custom-month" ><span className="text">{date.getFullYear()}</span>. {date.getMonth()+1}</div>
                        <button title = "다음" onClick={increaseMonth} >
                            <FontAwesomeIcon icon={faAngleRight} style={{fontSize:"12px"}} size="2x" /> {/*className="icon-arrow-right32"*/}
                        </button>
                     </div>   
                    )}
                />
            </div>
        )
    }
    
    const [tempDate, setTempDate] = useState(null)
    const [calEvents, setCalEvents] = useState([])
    const [calEventSource, setCalEventSource] = useState([])

    //FullCalendar Day
    const fullCalendarDayRef = useRef(null)
    const FullCalendarComponentDay = () => {
        const handleDateClick = e => {

            if((paramData?.PT_END_DT && moment(paramData.PT_END_DT).diff(Date.now(), "milliseconds", true) > 0 )) {
                alert(G.t('trem.lang.home.0750')) // 확정 취소후 변경 가능합니다.
            }else if(equipMstr.USE_OPT_FLAG === "Y" 
                && ((equipMstr.FIR_RG_FLAG == "Y" && equipMstr.RG_RESERV_TYPE == "02") 
                || (equipMstr.FIR_OC_FLAG == "Y" && equipMstr.OC_RESERV_TYPE == "02"))) {
                alert(<div>
                    <div>{G.t('trem.lang.home.0751')}</div>
                    <div>{G.t('trem.lang.home.0199')} : </div>{/* 예약기간 :  */}
                    <div>{
                        moment(startDate).format('YYYY-MM-DD HH:mm')
                        + " ~ "
                        + moment(endDate).format('YYYY-MM-DD HH:mm')}
                    </div>
                </div>)
            }else {
                selectCalendarDay(e.date)
            }
        }
        const selectCalendarDay = date => {
            let selectStart = null
            let selectEnd = null

            if(tempDate && moment(date).diff(tempDate, "minutes", true) > 0) {
                selectStart = tempDate
                selectEnd = moment(date).add(equipOperInfo.TIME_UNIT, 'minutes')._d

                setTempDate(null)
            }else {
                selectStart = date
                selectEnd = moment(selectStart).add(equipOperInfo.TIME_UNIT, 'minutes')._d
            
                setTempDate(date)
            }

            if( !checkCurrentTime(selectStart) ){
                setTempDate(null)
                return 
            }
            if( !checkCurrentEndTime(selectEnd) ){
                //setTempDate(null)
                return 
            }
            setRangeDate({startDate: selectStart, endDate: selectEnd}) 
                
            let useTime = moment(selectEnd).diff(selectStart, "hours", true)
                useTime = Math.round(useTime*100)/100
            setDataStore({...dataStore, paramData:{...paramData, USE_TIME: useTime}})
            setSelectCalendarEvent(selectStart, selectEnd, calEventSource, reservData)
            
            
            setPickerDate(selectEnd)
        }

        const timeUnit = equipOperInfo.TIME_UNIT
        let mStep = timeUnit > 1 && timeUnit < 30 ? "00:"+timeUnit : "00:30"

        return (
            <div className="d_calendar_wrap">
                <div className="calendar_t">
                    <ul>
                        <li><span className="c_color1"></span>{G.t('trem.lang.home.0010')}</li>{/* 장비예약 */}
                        <li><span className="c_color2"></span>{G.t('trem.lang.home.0083')}</li>{/* 유지보수 */}
                        <li><span className="c_color3"></span>{G.t('trem.lang.home.0084')}</li>{/* 업무외시간 */}
                        <li><span className="c_color4"></span>{G.t('trem.lang.home.0085')}</li>{/* 휴일 */}
                        <li><span className="c_color5"></span>{G.t('trem.lang.home.0086')}</li>{/* 운영자 타 일정 */}
                        <li><span className="c_color6"></span>{G.t('trem.lang.home.0087')}</li>{/* 현재 예약 구간 */}
                        <li><span className="c_color7"></span>{G.t('trem.lang.home.0088')}</li>{/* 예약불가 */}
                    </ul>
                </div>
                <FullCalendar
                    locale={ko.code}
                    plugins={[ dayGridPlugin, timeGridPlugin, interactionPlugin ]}
                    initialView="timeGridDay"
                    height="400px"
                    headerToolbar={false}
                    events={calEvents}
                    dateClick={handleDateClick}
                    initialDate={pickerDate? pickerDate : paramData.defaultDate}
                    slotLabelFormat={{
                        hour: 'numeric',
                        minute: '2-digit',
                        omitZeroMinute: false,
                        hour12: false 
                    }}
                    slotLabelInterval = '00:30:00'
                    scrollTime={startDate ? moment(startDate).format('HH:mm') : "09:00:00"}
                    slotDuration={mStep}
                    allDaySlot={false}
                    ref={fullCalendarDayRef}

                /> 
            </div>
        )
    }

    //FullCalendar Month
    const fullCalendarMonthRef = useRef(null)
    const FullCalendarComponentMonth = () => {
        const customButtons = {
            customPrev: {
                text: '이전',
                click: () => {
                    fullCalendarMonthRef.current._calendarApi.prev()
                    //clickPrevNext()
                }
            },
            customNext: {
                text: '다음',
                click: () => {
                    fullCalendarMonthRef.current._calendarApi.next()
                    //clickPrevNext()
                }
            }
        }

        const clickPrevNext = () => {
            const startDt = fullCalendarMonthRef.current._calendarApi.getDate()      
            setCalendarEvents(startDt)
            setPickerDate(moment(startDt).format('YYYY-MM-01'))
        }

        
        const handleDateClick = e => {
            //이전/다음달로 자동 넘어가면 이벤트 다시 가져와야함
            /* let prevDate = fullCalendarMonthRef.current._calendarApi.getCurrentData().currentDate
                prevDate = moment(prevDate).month()
            let handleDate = moment(e.date).month()
          
            if(prevDate != handleDate) {
                setCalendarEvents(e.date)
            }
            */
            
            if(paramData?.PT_END_DT && moment(paramData.PT_END_DT).diff(Date.now(), "milliseconds", true) > 0 ) {
                alert(G.t('trem.lang.home.0750')) // 확정 취소후 변경 가능합니다.
            }else if(equipMstr.USE_OPT_FLAG === "Y" 
                && ((equipMstr.FIR_RG_FLAG == "Y" && equipMstr.RG_RESERV_TYPE == "02") 
                || (equipMstr.FIR_OC_FLAG == "Y" && equipMstr.OC_RESERV_TYPE == "02"))) {
                alert(<div>
                    <div>{G.t('trem.lang.home.0751')}</div>
                    <div>{G.t('trem.lang.home.0199')} : </div>{/* 예약기간 :  */}
                    <div>{
                        moment(startDate).format('YYYY-MM-DD')
                        + " ~ "
                        + moment(endDate).format('YYYY-MM-DD')}
                    </div>
                </div>)
            }else {
                let selectStart = null
                let selectEnd = null
                if(tempDate && moment(e.date).diff(tempDate, "minutes", true) > 0) {
                    selectStart = tempDate
                    selectEnd = e.date
                
                    setTempDate(null)

                }else {
                    selectStart = e.date
                    selectEnd = e.date
                
                    setTempDate(e.date)
                }
                setRangeDate({startDate: selectStart, endDate: selectEnd})
                
                let useTime = moment(selectEnd).diff(selectStart, "days", true) + 1
                setDataStore({...dataStore, paramData:{...paramData, USE_TIME: useTime}})
            
                setSelectCalendarEvent(selectStart, selectEnd, calEventSource, reservData)

                setPickerDate(e.date)
            }
        }

        /* customFullCalendar */
        let fullCalendarStartMonth = pickerDate ? new Date(pickerDate).getMonth(): new Date(paramData.defaultDate).getMonth()
        let fullCalendarStartYear = pickerDate ? new Date(pickerDate).getFullYear(): new Date(paramData.defaultDate).getFullYear()

        const clickPrevNextMonth = (startDt)=>{
            setCalendarEvents(startDt)
            setPickerDate(moment(startDt).format('YYYY-MM-01'))
        }

        return (
            <div className="m_calendar_wrap">
                <div className="calendar_t" >
                    <ul>
                        <li><span className="c_color1"></span>{G.t('trem.lang.home.0010')}</li>{/* 장비예약 */}
                        <li><span className="c_color2"></span>{G.t('trem.lang.home.0083')}</li>{/* 유지보수 */}
                        <li><span className="c_color3"></span>{G.t('trem.lang.home.0084')}</li>{/* 업무외시간 */}
                        <li><span className="c_color4"></span>{G.t('trem.lang.home.0085')}</li>{/* 휴일 */}
                        <li><span className="c_color5"></span>{G.t('trem.lang.home.0086')}</li>{/* 운영자 타 일정 */}
                        <li><span className="c_color6"></span>{G.t('trem.lang.home.0087')}</li>{/* 현재 예약 구간 */}
                        <li><span className="c_color7"></span>{G.t('trem.lang.home.0088')}</li>{/* 예약불가 */}
                    </ul>
                </div>

                {<FullCalendar
                    locale={ko.code}
                    plugins={[ dayGridPlugin, interactionPlugin ]}
                    initialView="dayGridMonth"
                    height="600px"
                    headerToolbar={{
                        left: 'customPrev customNext title',
                        center: '',
                        right: '',
                    }}
                    buttonText={{
                        customPrev : '이전',
                        customNext : '다음',
                    }}
                    events={calEvents}
                    dateClick={handleDateClick}
                    initialDate={pickerDate ? pickerDate : paramData.defaultDate}                   
                    ref={fullCalendarMonthRef}
                    customButtons={customButtons}
                    validRange={{
                        start: paramData.defaultDate,
                        end: moment(paramData.maxDate).add(1, 'days')._d
                    }}
                    editable={false}
                /> }
                {/* 웹접근성 캘린더
                <FullCalendarCustom 
                startMonth = {fullCalendarStartMonth}
                startYear = {fullCalendarStartYear}
                schedules={calEvents} 
                prevNextMonth={clickPrevNextMonth} 
                schedulesDetail = {true}
                />  */}
            </div>
        )
    }


    const setCalendarEvents = async (startDt, bookingType) => {
        let startDtStr = moment(startDt).format('YYYY-MM-DD')
        let endDtStr = moment(startDt).add(1, 'days').format('YYYY-MM-DD')

        // 1일예약
        //let startDtStrSave = moment(startDt).format('YYYY-MM-DD')
        if(equipOperInfo.TIME_UNIT === '1') {
            startDtStr = moment(startDt).format('YYYY-MM-01')
            endDtStr = moment(startDt).add(1, 'months').format('YYYY-MM-DD')
        }
        
        const param = {
            EQUIP_SKEY          : equipMstr.EQUIP_SKEY,
            START_DT_STR        : startDtStr,
            END_DT_STR          : endDtStr,
            AUTH_TYPE           : requesterUserInfo.AUTH_TYPE,
            BOOKING_TYPE        : bookingType ? bookingType : paramData.BOOKING_TYPE,
            OPER_SKEY           : equipOperInfo.OPER_SKEY,
            DUPICATE_RESERV_FLAG: paramData.DUPICATE_RESERV_FLAG,
            FLAG_NOT_OBSERVER   : paramData.FLAG_NOT_OBSERVER,
            FLAG_ALL_AUTH       : paramData.FLAG_ALL_AUTH,
            SCHED_KIND          : equipOperInfo.SCHED_KIND,
            RECESS_FLAG         : equipOperInfo.RECESS_FLAG,
            TIME_UNIT           : equipOperInfo.TIME_UNIT,
            lang                : 'ko',
            //선착순
            FIR_CM_SCH_SKEY	    : equipMstr.FIR_CM_SCH_SKEY,
            FIR_RG_FLAG		    : equipMstr.FIR_RG_FLAG, //정기예약여부
            RG_RESERV_TYPE	    : equipMstr.RG_RESERV_TYPE, //정기유형
            FIR_OC_FLAG		    : equipMstr.FIR_OC_FLAG, //수시예약여부
            OC_RESERV_TYPE	    : equipMstr.OC_RESERV_TYPE, //수시유형
        }
        let eventList = await tremApi('/r/hm/equipReservation/reservation/calendar',  nullCheckParameter(param))
        if(equipOperInfo.TIME_UNIT === '1') {
            eventList.map((obj) => {
                obj.start = moment(obj.start).format('YYYY-MM-DD')
                obj.end = moment(obj.end).format('YYYY-MM-DD')
                return obj
            })
        }
        
        setCalEventSource(eventList)
        setSelectCalendarEvent(startDate, endDate, eventList, reservData)
           
        
    }

    const setSelectCalendarEvent = async (selectStart, selectEnd, eventList, reservData) => {

        const {equipOperInfo, equipOperSpList} = reservData

        let reEventList = new Array(...eventList)

        if(selectStart && selectEnd) {

            let eventObj = {}
            if(equipOperInfo.TIME_UNIT === '1') {
                //웹 접근성 추가
                eventObj = {title: `${G.t('trem.lang.home.0087')}`, start: moment(selectStart).format('YYYY-MM-DD'), end: moment(selectEnd).add(1, 'days').format('YYYY-MM-DD'), color: '#c15726'}
                /* eventObj = {title: '예약(신청)' ~~} */
            } else {
                //웹 접근성 추가
                eventObj = {title: `${G.t('trem.lang.home.0087')}`, start: moment(selectStart).format('YYYY-MM-DD HH:mm'), end: moment(selectEnd).format('YYYY-MM-DD HH:mm'), color: '#c15726'}
                /* eventObj = {title: '예약신청구간' ~~} */
            }

            reEventList.push(eventObj)
            
            //특수예약
            equipOperSpList.length > 0 && setEquipSpecial(selectStart, selectEnd, reservData)
            
            //중복체크 문구
            const startDt = moment(selectStart).format('YYYY-MM-DD HH:mm')
            const endDt = !selectEnd ? ''
                            : equipOperInfo.TIME_UNIT == '1'
                            ? moment(selectEnd).add(1, "days").format("YYYY-MM-DD HH:mm")
                            : moment(selectEnd).format("YYYY-MM-DD HH:mm")

            let check_param = {
                EQUIP_SKEY      : equipMstr.EQUIP_SKEY,
                OPER_SKEY       : equipOperInfo.OPER_SKEY,
                DUPICATE_RESERV_FLAG: paramData.DUPICATE_RESERV_FLAG,
                AUTH_TYPE       : requesterUserInfo.AUTH_TYPE,
                BOOKING_TYPE    : paramData.BOOKING_TYPE,
                START_DT_STR    : startDt,
                END_DT_STR      : endDt,
                FLAG_NOT_OBSERVER: paramData.FLAG_NOT_OBSERVER,
                FLAG_ALL_AUTH   : paramData.FLAG_ALL_AUTH,
                SCHED_KIND      : equipOperInfo.SCHED_KIND,
                FLAG_AUTO_TIME  : paramData.FLAG_AUTO_TIME,
                managerFlag     : false,
                RECESS_FLAG     : equipOperInfo.RECESS_FLAG,
                TIME_UNIT       : equipOperInfo.TIME_UNIT,
                lang            : 'ko',
                //선착순
                FIR_CM_SCH_SKEY	: equipMstr.FIR_CM_SCH_SKEY,
                FIR_RG_FLAG		: equipMstr.FIR_RG_FLAG, //정기예약여부
                RG_RESERV_TYPE	: equipMstr.RG_RESERV_TYPE, //정기유형
                FIR_OC_FLAG		: equipMstr.FIR_OC_FLAG, //수시예약여부
                OC_RESERV_TYPE	: equipMstr.OC_RESERV_TYPE, //수시유형
            }
            
            // 슈퍼유저, 셀프유저인 경우 예약옵션에 따라서 스케줄을 보여줌.
            const checkData = await tremApi('/r/hm/equipReservation/reservation/calendar/check', nullCheckParameter(check_param)).then(data => {
                return data
            }).catch(err => {
                alert(G.t('trem.lang.home.0836')+'3', err)/* 오류발생3 */
            })
            if(checkData && checkData > 0 && (equipOperInfo?.CHARGE_TYPE !="05" && equipOperInfo?.CHARGE_TYPE !="06")) {
                setNoticeData({
                    noticeFlag : true,
                    noticeMsg : G.t('trem.lang.home.0730') //선택하신 시간에 다른 일정이 존재합니다.
                })
                    // 담당자 일정확인 후 예약 막기 (20220721 주석 - 확인필요)
                    // // 일정이 있으면 선택시간(selectStart, selectEnd) 지우기
                    // if(requesterUserInfo.AUTH_TYPE == 5){ // 일반유저 
                    //     alert(G.t('trem.lang.home.0730')).then(()=>{
                    //         reEventList.splice(-1,1) 
                    //         setCalEvents(reEventList)
                    //         setRangeDate({startDate: null, endDate: null})
                    //     })
                    // }else{
                    //     // 직접이용이 아닌 경우
                    //     if(paramData.BOOKING_TYPE != 'SU'){
                    //         alert(G.t('trem.lang.home.0730')).then(()=>{
                    //             reEventList.splice(-1,1) 
                    //             setCalEvents(reEventList)
                    //             setRangeDate({startDate: null, endDate: null})
                    //         })
                    //     }
                    // }
            }else {
                setNoticeData({
                    noticeFlag : false
                }) 
                // setCalEvents(reEventList)
               
            }
            
            
        }
        // else{
        //     setCalEvents(reEventList)
        // }
        setCalEvents(reEventList)
    }

    // 영역제어
    const areaControllFn = (areaName, areaStatus) =>{ // className명, 영역상태
        if(areaStatus){ // 닫기 -> 배열추가
            let list = []
            list = list.concat(areaControll)
            list.push(areaName)
            setAreaControll(list)
        }else{ // 열기 -> 배열삭제
            const saveArea = areaControll.filter((o)=>o !== areaName)
            setAreaControll(saveArea)
        }
    }

    const checkCurrentTime = (selectDT) =>{

        // 현재 시간 체크   
        const currentDate = moment(new Date()).format('YYYY-MM-DD HH:mm') 
        const startDt = moment(selectDT).format('YYYY-MM-DD HH:mm')

        const currentDay = moment(new Date()).format('YYYY-MM-DD') 
        const startDaty = moment(selectDT).format('YYYY-MM-DD')

        if( startDaty === currentDay && startDt < currentDate  ) {
            alert(G.t('trem.lang.home.0932'))//현재시간 이후 예약가능 합니다.
            return false
        }

        if(paramData.timeUnit != 1){
           
            const  checkDefaultDate = moment(paramData.defaultDate).format('YYYY-MM-DD HH:mm')
            const  checkMaxDate = moment(paramData.maxDate).format('YYYY-MM-DD HH:mm')
            
            if (checkDefaultDate > startDt || checkMaxDate < moment(startDt).add(equipOperInfo.timeUnit,'minute')._i){
                alert(<span>{G.t('trem.lang.home.1042') /* 예약허용시간이 아닙니다. */}<br/> {G.t('trem.lang.home.1043') /* 예약허용기간 */} : {checkDefaultDate} ~ {checkMaxDate} </span>)
                return false
            }
        }
        
        return true
    }

    // 두번째 click
    const checkCurrentEndTime = (selectDT) =>{
        // 현재 시간 체크   
        const endDt = moment(selectDT).format('YYYY-MM-DD HH:mm')
       
        if(paramData.timeUnit != 1){
            const  checkDefaultDate = moment(paramData.defaultDate).format('YYYY-MM-DD HH:mm')
            const  checkMaxDate = moment(paramData.maxDate).format('YYYY-MM-DD HH:mm')

            if (checkDefaultDate > endDt || checkMaxDate < endDt){
                alert(<span>{G.t('trem.lang.home.1042') /* 예약허용시간이 아닙니다. */}<br/> {G.t('trem.lang.home.1043') /* 예약허용기간 */} : {checkDefaultDate} ~ {checkMaxDate} </span>)
                return false
            }
        }
        
        return true
    }

    // 이용중인 언어
    const currentLang = Cookies.get('__floor_lang__') || 'ko'

    // tab키로 이동
    const handleKeyPress = (e, i) =>{
        if(e.charCode === 13) { // enter
            //값 변경
            const param = { ...paramData }
            const targetEle = e.target.childNodes[0]
            if(targetEle.type === 'checkbox') {
                targetEle.checked 
                ? param[targetEle.name] = "Y"
                : param[targetEle.name] = "N"
            }else if(targetEle.className === 'OPT_MRO_LIST') {
                let OPT_MRO_LIST = paramData.OPT_MRO_LIST
                OPT_MRO_LIST[i].QUENTITY = targetEle.value
                param['OPT_MRO_LIST'] = OPT_MRO_LIST
            }else if(targetEle.className === 'MRO_LIST') {
                let MRO_LIST = paramData.MRO_LIST
                MRO_LIST[i].QUENTITY = targetEle.value
                param['MRO_LIST'] = MRO_LIST
            }else {
                param[targetEle.name] = targetEle.value
                if (targetEle.name === 'BOOKING_TYPE') {
                    targetEle.value != 'WE' && targetEle.value != 'WU'
                        ? (param['UA_EDU_SKEY'] = '')
                        : targetEle.value != 'EX'
                        ? (param['EXPERT_SKEY'] = '')
                        : null
                    setTempDate(null)
                    setCalendarEvents(paramData.defaultDate, targetEle.value)
                }
            }
            setDataStore({ ...dataStore, paramData: param })
            setPickerDate(paramData.defaultDate)
        }
    }

    useMemo(() => {
        if(rangeDate.startDate != null && rangeDate.endDate != null){
            setCalendarEvents(rangeDate.startDate)
        }
    }, [rangeDate])

    //블랙리스트 알림 팝업
    const blackPopupProps = usePopup('알림')
    const blackPopupButtons = [
       {
           title:'닫기',
           handler:()=>{
               G.gotoPage('/home/equip/reserv/list')
           }
       }
    ]

    
    return (
        <Fragment>
            {/*Reserv Info 장비예약자정보*/}
            <div className="box_btn" style={{top:"60px"}}>
            {
                areaControll.includes('q_info')
                ?<a href="javascript:void(0);" className="close" onClick={()=>{areaControllFn("q_info", false)}} >열기</a>
                :<a href="javascript:void(0);" className="open" onClick={()=>{areaControllFn("q_info",true)}}>닫기</a>
            }
            </div>
            <a title="새창" href="javascript:void(0);" className="btn_help2" style={{top: '70px', right:'30px'}} onClick={() => { TF.goHelp("/hm/manual/equipReservation/detail")}}>도움말</a>
            {
            areaControll.includes('q_info')
            ||<div className="q_info">
                <h3 className='hidden'>{G.t('trem.lang.home.0010')}</h3>
                <ul>
                    <li>
                        <img alt={equipMstr.KOR_NM+" 사진"} src={R.isNil(equipMstr.PHOTO_FILE_SKEY) || equipMstr.PHOTO_FILE_SKEY === 0 ? equipMstr.PHOTO_URL || serverUrl+serverPrefixUrl+"/resources/images/gist/common/no_image.jpg" : TF.getPhotoURL(equipMstr.PHOTO_FILE_SKEY) }/>          
                    </li>
                    <li>
                        <p>{equipMstr.ENG_NM}</p>
                        <h3>{equipMstr.KOR_NM}</h3>
                        
                        <dl>
                            <dt>{G.t('trem.lang.home.0049')}</dt>{/* 예약자 */}
                            <dd>
                                {requesterUserInfo.NAME}
                                {managerFlag && (
                                    <a href="javascript:void(0);" className="btn_modify" onClick={() => {userPopupProps.setOpen(true)}}>
                                        {G.t('trem.lang.home.0341')}
                                        {/* 수정 */}
                                    </a>
                                )}
                            </dd>
                            <dt>{G.t('trem.lang.home.0050')}</dt>{/* 연락처 */}
                            <dd>{requesterUserInfo.MOBILE_NO}</dd>
                            <dt>{G.t('trem.lang.home.0051')}</dt>{/* 계산서 */}
                            <dd>
                                {paramData?.COMPANY_NAME}
                                {managerFlag && (
                                    <a href="javascript:void(0);" className="btn_modify" onClick={() => {deptPopupProps.setOpen(true)}}>
                                       {G.t('trem.lang.home.0341')}
                                       {/* 수정 */}
                                    </a>
                                )}
                            </dd>
                        </dl>
                        <ul className="reser_use">
                            <li>
                                <h4>
                                {G.t('trem.lang.home.0052')}{/* 이용권한 */}
                                    <br />
                                    <span>({requesterUserInfo.AUTH_TYPE_NAME})</span>
                                </h4>
                            </li>
                            <li>
                                <p tabIndex="0">
                                    {requesterUserInfo.AUTH_TERM_DAY ? (
                                        <b>
                                            {G.t('trem.lang.home.0752')} <span>{requesterUserInfo.AUTH_TERM_DAY}</span>{' '} {/* 권한 만료 */}
                                            {G.t('trem.lang.home.0545')} {G.t('trem.lang.home.0757')} {/* 일 병행교육선택 */}
                                        </b>
                                    ) : !requesterUserInfo.AUTH_TERM_DAY ||
                                    requesterUserInfo.UNLIMIT_AUTH_FLAG === 'Y' ? (
                                        <b>{G.t('trem.lang.home.0056')}</b>/* 권한 만료 기간 없음 */
                                    ) : (
                                        <b></b>
                                    )}
                                    <br />
                                    {G.t('trem.lang.home.0057')} {equipOperInfo.START_TIME}시 ~{' '}{/* 예약가능 시간은 ~~시 */}
                                    {equipOperInfo.END_TIME}시{G.t('trem.lang.home.0767')} {/* ~시 까지 가능합니다 */}
                                    <br />
                                    <span>{G.t('trem.lang.home.0058')}</span>{/* 토요일 일요일은 예약이 불가능 합니다. */}
                                    {equipOperInfo.FLAG_ALL_AUTH === 'Y'
                                        ? `* (${G.t('trem.lang.home.0754')})` // 직접이용시 예약가능 시간은 24시간 연중 무휴입니다.
                                        : ''}
                                    <br />
                                    {G.t('trem.lang.home.0059')}{/* 이용의뢰, 교육병행의뢰 예약은 운영자 업무시간에 한합니다. */}
                                    <br />
                                    {discountList?.length > 0 &&
                                        '- '+G.t('trem.lang.home.0060')}{/* 할인정책이 존재합니다. 예약전 확인해 주세요 */}
                                    <br />
                                    {penaltyList?.length > 0 &&
                                        '- '+G.t('trem.lang.home.0755')} {/* 패널티정책이 존재합니다. 예약전 확인해 주세요. */}
                                </p>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            }

            <div className="relative">
                <h3 className="tt_type1">
                    예약옵션
                    <div className="box_btn" style={{top:"10px"}}>
                        {
                            areaControll.includes('e_option')
                            ?<a href="javascript:void(0);" className="close" onClick={()=>{areaControllFn("e_option", false)}} >열기</a>
                            :<a href="javascript:void(0);" className="open" onClick={()=>{areaControllFn("e_option", true)}}>닫기</a>
                        }
                    </div>
                </h3>
                
                {
                areaControll.includes('e_option')
                ||<Fragment>
                    <fieldset className="e_option mb-6" role="group">
                        {params.OPER_LIST?.map((obj, index) => {
                            const selectOper = (e) => {
                                getReservDetail(requesterUserInfo.USER_SKEY, equipMstr.EQUIP_SKEY, obj.OPER_SKEY, equipMstr.FIR_CM_SCH_SKEY)
                            }
                            return <Fragment key={index} >
                                <span aria-checked = {obj.OPER_SKEY === equipOperInfo.OPER_SKEY} onChange={G.radioHandleClick} tabIndex = "0" role="radio" onKeyPress = {(e)=> {e.code ==="Enter"? selectOper():""}}>
                                    <input title="예약옵션 선택" type="radio" name="OPER_SKEY" id={"OPER_SKEY"+index} checked={obj.OPER_SKEY === equipOperInfo.OPER_SKEY} onChange={selectOper}/>
                                    <label htmlFor={"OPER_SKEY"+index}>{currentLang === 'ko' ? obj.NAME : obj.NAME_ENG}</label>
                                </span>
                            </Fragment>
                        })}                              
                    </fieldset>
                    <div className="e_option mb-6" role="group">
                        {equipFirstComeList.map((obj, index) => {
                            const selectFch = (e) => {
                                getReservDetail(requesterUserInfo.USER_SKEY, equipMstr.EQUIP_SKEY, equipOperInfo.OPER_SKEY, obj.FIR_CM_SCH_SKEY)
                            }
                            return <div key={index} role="radio">
                                <input title="선착순 예약 선택" aria-checked={obj.FIR_CM_SCH_SKEY === equipMstr.FIR_CM_SCH_SKEY} type="radio" name="FIR_CM_SCH_SKEY" id={"FIR_CM_SCH_SKEY"+index} checked={obj.FIR_CM_SCH_SKEY === equipMstr.FIR_CM_SCH_SKEY} onChange={selectFch}/>
                                <label htmlFor={"FIR_CM_SCH_SKEY"+index}>{obj.SCH_TITLE}</label>
                                <div className="e_opt_term">
                                    <span>{G.t('trem.lang.home.0177')} : {obj.SCH_START_DT_STR } ~ {obj.SCH_END_DT_STR }</span>{/* 신청기간 : ~~ ~ ~~ */}
                                    <span>{G.t('trem.lang.home.0199')} : {obj.RESERV_START_DT_STR } ~ {obj.RESERV_END_DT_STR }</span>{/* 예약기간 : ~~ ~ ~~ */}
                                </div>
                            </div>
                        })}    
                    </div> 


                    {/*Method Tab 이용방법*/}
                    <EquipUseMethod dataStore={dataStore}/>
                </Fragment>
                }    

                <div className="e_method">  
                    {
                        areaControll.includes('e_option')
                        ||<Fragment>
                            <h3 className="tt_type2">{G.t('trem.lang.home.0076')}</h3>{/* 장비예약 안내 */}
                            <p className="text_box3"><span dangerouslySetInnerHTML={{ __html: equipOperInfo.RESERV_INFO}}/></p>
                        </Fragment>
                    }
                    <div className="step_box">
                        <div className="step_tt">
                            <h4><span>STEP 1</span>{G.t('trem.lang.home.0061')}</h4>{/* 이용방법 */}
                            <div className="box_btn">
                            {
                                areaControll.includes('step_box1')
                                ?<a href="javascript:void(0);" className="close" onClick={()=>{areaControllFn("step_box1", false)}} >열기</a>
                                :<a href="javascript:void(0);" className="open" onClick={()=>{areaControllFn("step_box1", true)}} >닫기</a>
                            }
                            </div>
                            <a title="새창"
                            href="javascript:void(0);"
                            style={{right: '55px'}} 
                            onClick={() => {TF.goHelp("/hm/manual/equipReservation/detail/use")}}
                            >도움말</a>
                        </div>
                        {
                         areaControll.includes('step_box1')
                        ||<div className="option_box">
                            <div className="e_option" role="group">
                            {equipOperInfo.FLAG_SELF_USE != 'N' && 
                                    <div onClick={G.radioHandleClick} tabIndex={0} aria-checked={"SU" === paramData.BOOKING_TYPE} role="radio" onKeyPress = {(e)=>{handleKeyPress(e, handleChangeData)}}>
                                        <input type="radio" title="예약옵션 선택" value="SU" id={"BOOKING_TYPE_SU"} name="BOOKING_TYPE" checked={"SU" === paramData.BOOKING_TYPE} onChange={handleChangeData} />
                                        <label htmlFor={"BOOKING_TYPE_SU" }>{G.t('trem.lang.home.0268')}</label>{/* 직접이용 */}
                                    </div>
                                }
                                {equipOperInfo.FLAG_EXPERT == 'Y' && 
                                    <div onClick={G.radioHandleClick} tabIndex={0} aria-checked={"EX" === paramData.BOOKING_TYPE} role="radio" onKeyPress = {(e)=>{handleKeyPress(e, handleChangeData)}}>
                                        <input type="radio" title="예약옵션 선택" value="EX" id={"BOOKING_TYPE_EX"} name="BOOKING_TYPE" checked={"EX" === paramData.BOOKING_TYPE} onChange={handleChangeData} />
                                        <label htmlFor={"BOOKING_TYPE_EX" }>{G.t('trem.lang.home.0080')}</label>{/* 일반이용(with전문가) */}
                                    </div>
                                }
                                {equipOperInfo.FLAG_REQ != 'N' && 
                                    <div onClick={G.radioHandleClick} tabIndex={0} aria-checked={"RE" === paramData.BOOKING_TYPE} role="radio" onKeyPress = {(e)=>{handleKeyPress(e, handleChangeData)}}>
                                        <input type="radio" title="예약옵션 선택" value="RE" id={"BOOKING_TYPE_RE"} name="BOOKING_TYPE" checked={"RE" === paramData.BOOKING_TYPE} onChange={handleChangeData} />
                                        <label htmlFor={"BOOKING_TYPE_RE" }>{G.t('trem.lang.home.0078')}</label>{/* 이용의뢰 */}
                                    </div>}
                                {(equipOperInfo.FLAG_WITH_EDU != 'N' && eduList && eduList.length > 0) &&
                                    <Fragment>
                                        <div onClick={G.radioHandleClick} tabIndex={0} aria-checked={"WE" === paramData.BOOKING_TYPE} role="radio" onKeyPress = {(e)=>{handleKeyPress(e, handleChangeData)}}>
                                            <input type="radio" title="예약옵션 선택" value="WE" id={"BOOKING_TYPE_WE"} name="BOOKING_TYPE" checked={"WE" === paramData.BOOKING_TYPE} onChange={handleChangeData} />
                                            <label htmlFor={"BOOKING_TYPE_WE" }>{G.t('trem.lang.home.0079')}</label>{/* 교육병행의뢰 */}
                                        </div>
                                        <div onClick={G.radioHandleClick} tabIndex={0} aria-checked={"WU" === paramData.BOOKING_TYPE} role="radio" onKeyPress = {(e)=>{handleKeyPress(e, handleChangeData)}}>
                                            <input type="radio" title="예약옵션 선택" value="WU" id={"BOOKING_TYPE_WU"} name="BOOKING_TYPE" checked={"WU" === paramData.BOOKING_TYPE} onChange={handleChangeData} />
                                            <label htmlFor={"BOOKING_TYPE_WU" }>{G.t('trem.lang.home.0081')}</label>{/* 교육병행이용 */}
                                        </div>
                                        <select name="UA_EDU_SKEY" title="대분류 구분" onChange={handleChangeData} value={paramData.UA_EDU_SKEY || ''} disabled={paramData.BOOKING_TYPE != 'WE' && paramData.BOOKING_TYPE != 'WU'} >
                                            <option value="">{G.t('trem.lang.home.0757')}</option> {/* 병행교육선택 */}
                                            {eduList.map((obj, index) => {
                                                return <option key={index} value={obj.UA_EDU_SKEY}>{obj.EVENT_NAME}</option>
                                            })}
                                        </select>
                                    </Fragment>
                                }                            
                            </div>
                        </div>
                        }
                    </div>
                    <div className="step_box">
                        <div className="step_tt">
                            <h4><span>STEP 2</span>{G.t('trem.lang.home.0082')}</h4>{/* <h4><span>STEP 2</span>장비 스케쥴 선택</h4> */}
                            <div className="box_btn">
                            {
                                areaControll.includes('step_box2')
                                ?<a href="javascript:void(0);" title='접힘' className="close" onClick={()=>{areaControllFn("step_box2", false)}} >열기</a>
                                :<a href="javascript:void(0);" title='펼쳐짐' className="open" onClick={()=>{areaControllFn("step_box2",true)}}>닫기</a>
                            }
                            </div>
                        </div>
                        
                        <div style={equipOperInfo.TIME_UNIT != '1' ?{display:'flex', flexDirection:'column-reverse'}:{}}>
                            {
                            areaControll.includes('step_box2')
                            ||<div >
                                {equipOperInfo.FLAG_AUTO_TIME === 'Y'
                                ? <Fragment>
                                    <div className="reserv_time">
                                        <p className="notice2">
                                            <span className="info">!</span>
                                            현재 장비의 과금 기준은 (
                                            <span className="font-medium">
                                                <span className={equipOperInfo.CHARGE_TYPE === '01' ? "text-red-500" : ""}>{G.t('trem.lang.home.0090')}</span>,{/* 시간 */}
                                                <span className={equipOperInfo.CHARGE_TYPE === '02' ? "text-red-500" : ""}> 시료</span>,
                                                <span className={equipOperInfo.CHARGE_TYPE === '03' ? "text-red-500" : ""}> {G.t('trem.lang.home.0094')}</span>{/* 시험횟수 */}
                                            </span>
                                            ) 기준이며 기본 (
                                            <span className="font-medium">
                                                {
                                                    equipOperInfo.TIME_UNIT === '1' 
                                                    ? (equipOperInfo.TIME_UNIT * paramData.minTimeUnit)+G.t('trem.lang.home.0545')/* 일 */
                                                    : (equipOperInfo.TIME_UNIT * paramData.minTimeUnit)+"분"
                                                }
                                                {equipOperInfo.DEFAULT_QUENTITY > 0 && ", "+equipOperInfo.DEFAULT_QUENTITY+"시료"}
                                                {equipOperInfo.DEFAULT_REPEAT > 0 && ", "+equipOperInfo.DEFAULT_REPEAT+ `${G.t('trem.lang.home.0094')}`}{/* , ~~시험횟수 */}
                                            </span>
                                            ) 입니다.<br/>
                                            {G.t('trem.lang.home.0148')}
                                            {/* 자동으로 예약시간이 부여됩니다. 요약 과금과 최종 청구 금액이 다를 수 있습니다. */}
                                        </p>
                                        <ul>
                                            <li>
                                                <label htmlFor="EQ_QUENTITY">{G.t('trem.lang.home.0633')}</label>
                                                <input title="시료수 입력" type="number" id="EQ_QUENTITY" name="EQ_QUENTITY" min="0" value={paramData.QUENTITY} onChange={handleChangeData} readOnly={equipOperInfo.CHARGE_TYPE === '01' || equipOperInfo.CHARGE_TYPE === '03'}/>
                                            </li>
                                            <li>
                                                <label htmlFor="EQ_REPEAT_COUNT">{G.t('trem.lang.home.0094')}</label>{/* 시험횟수 */}
                                                <input title="시험횟수 입력" type="number" id="EQ_REPEAT_COUNT" name="EQ_REPEAT_COUNT" min="0" value={paramData.REPEAT_COUNT} onChange={handleChangeData} readOnly={equipOperInfo.CHARGE_TYPE === '01' || equipOperInfo.CHARGE_TYPE === '02'}/>
                                            </li>
                                        </ul>
                                    </div>
                                </Fragment>
                                : <Fragment>
                                    <div className="my-5">
                                        {equipOperInfo.TIME_UNIT === '1'
                                        ? <div>
                                            <FullCalendarComponentMonth />
                                        </div>
                                        :<Fragment>
                                        <div>
                                            <div className="flex lg:flex-row flex-col f_calendar"> 
                                                { <div className="d_datepicker mr-10 lg:w-1/3 w-full">
                                                    <DatePickerComponentDate />
                                                </div> }
                                                <div className="lg:w-2/3 w-full">{/* className="w-full" */}
                                                    <FullCalendarComponentDay />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='text-right '>
                                            <span className='text-red-700 text-sm'>※ 마우스 선택시 주의사항 : 첫번째 지정일은 시작일, 두번째 지정일은 종료일</span>
                                        </div>
                                        </Fragment>
                                        }
                                        
                                    </div>
                                </Fragment>}
                                
                            </div>}
                            {/* {equipOperInfo.TIME_UNIT ==='1' // 시간예약인 경우 scheduler보다 위에 배치_웹접근성 
                            &&  */}
                            <div className="reserv_time">
                                <p className={"notice" + (noticeFlag ? "" : "hidden")}><span className="info">!</span>{noticeMsg}</p>
                                
                                {
                                equipOperInfo.FLAG_NOT_USE != 'Y' /*예약불가x*/ 
                                && equipOperInfo.FLAG_AUTO_TIME != 'Y' /*시간자동배정x*/
                                && ( /*선취득 시설이용권한 없음*/
                                    requesterUserInfo.FLAG_PRE_FUA != 'Y'
                                    || (requesterUserInfo.FLAG_PRE_FUA == 'Y' && requesterUserInfo.FLAG_CHECK_FUA == 'Y')
                                )
                                && <ul style={noticeFlag ? {borderTop: '1px solid #d9514c'} : {}}>
                                        <li>
                                            <label htmlFor="USE_TIME">{G.t('trem.lang.home.0089')}</label>{/* 총예약시간 */}
                                            <input type="text" id="USE_TIME" name="USE_TIME" readOnly={true} value={paramData.USE_TIME || 0} title={G.t('trem.lang.home.0089')} style={{width: '60px'}}/> {/* 총예약시간 */}
                                            {equipOperInfo.TIME_UNIT === '1' ? G.t('trem.lang.home.0785') : G.t('trem.lang.home.0090')}{/* equipOperInfo.TIME_UNIT === '1' ? 일 : '시간' */}                                    
                                        </li>
                                        <li>
                                            {equipOperInfo.TIME_UNIT === '1'
                                            ? <DatePickerComponentMonth />
                                            : <DatePickerComponentDay />
                                            }
                                        </li>
                                        <li>
                                            
                                        {equipOperInfo?.CHARGE_TYPE != "05"&& equipOperInfo?.CHARGE_TYPE != "06"&&(
                                            <Fragment>
                                            <label htmlFor="QUENTITY">{G.t('trem.lang.home.0633')}</label>
                                            <input title="시료수 입력" name="QUENTITY" type="number" id="QUENTITY" min="0" value={paramData.QUENTITY || 0} onChange={handleChangeData} readOnly={equipOperInfo.CHARGE_TYPE === '01' || equipOperInfo.CHARGE_TYPE === '03'}/>
                                            </Fragment>
                                        )}
                                        </li>
                                        <li>
                                        {equipOperInfo?.CHARGE_TYPE != "05"&&equipOperInfo?.CHARGE_TYPE != "06"&&(
                                            <Fragment>
                                            <label htmlFor="REPEAT_COUNT">{G.t('trem.lang.home.0094')}</label>{/* 시험횟수 */}
                                            <input title="시험횟수 입력" name="REPEAT_COUNT" type="number" id="REPEAT_COUNT" min="0" value={paramData.REPEAT_COUNT || 0} onChange={handleChangeData} readOnly={equipOperInfo.CHARGE_TYPE === '01' || equipOperInfo.CHARGE_TYPE === '02'}/>
                                            </Fragment>
                                        )}
                                        </li>
                                        
                                        <li className="hidden">
                                            <label htmlFor="REPEAT_AREA_COUNT">{G.t('trem.lang.home.0594')}</label>{/* 칸수 */}
                                            <input title="칸수 입력" name="REPEAT_AREA_COUNT" type="number" id="REPEAT_AREA_COUNT" min="0" value={spChkData.length || 0} onChange={handleChangeData} readOnly={true}/>
                                        </li>
                                    </ul>
                                }
                            </div>
                            {/* } */}
                        </div>
                    </div>
                    
                    
                    
                    
                        {paramData.FLAG_PREEMPTIVE === 'Y'
                        && <Fragment>
                            <div className="btn_type1">
                                {paramData.PREEMPTIVE_SKEY 
                                ? <a href="javascript:void(0);" className="red" onClick={preemptiveCancel}>{G.t('trem.lang.home.0758')}</a> /* 확정취소 */
                                : <a href="javascript:void(0);" className="red" onClick={preemptiveSave}>{G.t('trem.lang.home.0759')}</a>} {/*예약시간 확정*/}
                            </div>
                        </Fragment>
                        }
                    


                        {equipOperInfo.FLAG_NOT_USE != 'Y'
                        && ( /*선취득 시설이용권한 없음*/
                            requesterUserInfo.FLAG_PRE_FUA != 'Y'
                            || (requesterUserInfo.FLAG_PRE_FUA == 'Y' && requesterUserInfo.FLAG_CHECK_FUA == 'Y')
                        )
                        && (/*선점예약 체크*/
                            paramData.FLAG_PREEMPTIVE != "Y"
                            || (paramData.FLAG_PREEMPTIVE === 'Y' && paramData.PREEMPTIVE_SKEY)
                        )
                        && <Fragment>
                            <div className="step_box">
                                {/*선점예약*/
                                (paramData?.PT_END_DT && moment(paramData.PT_END_DT).diff(Date.now(), "milliseconds", true) > 0 ) && <Fragment>
                                    <div className="preemptive_countdown">
                                        <span>해당시간</span>
                                        <span>
                                            <Countdown 
                                                date={Date.now() + (moment(paramData.PT_END_DT).diff(Date.now(), "milliseconds", true))}
                                                renderer={props => {
                                                    const {formatted, completed} = props
                                                    if(completed) {
                                                        alert(G.t('trem.lang.home.0760')) //입력시간이 종료되어 확정시간이 해제 되었습니다.
                                                        
                                                        setDataStore({...dataStore, paramData: {...paramData, PREEMPTIVE_SKEY: null, PT_END_DT: null}})
                                                        setRangeDate({startDate: null, endDate: null})
                                                    }
                                                    return <Fragment>
                                                        <span className="countdown_wrap">{formatted.minutes}</span>
                                                        <span> : </span>
                                                        <span className="countdown_wrap">{formatted.seconds}</span>
                                                    </Fragment>
                                                }}
                                            />
                                        </span>
                                        <span> 까지 입력을 하셔야 합니다.</span>
                                    </div>
                                </Fragment>
                                }


                                {/*특수예약*/}
                                {equipOperSpList.length > 0
                                && <div className="step_box">
                                        <div className="step_tt">
                                            <h4><span>STEP 2-1</span>{G.t('trem.lang.home.0761')}</h4> {/* 예약 선택 */}
                                            <div className="box_btn">
                                            {
                                                areaControll.includes('step_box2-1')
                                                ?<a href="javascript:void(0);" className="close" onClick={()=>{areaControllFn("step_box2-1", false)}} >열기</a>
                                                :<a href="javascript:void(0);" className="open" onClick={()=>{areaControllFn("step_box2-1",true)}}>닫기</a>
                                            }
                                            </div>
                                        </div>
                                        {
                                           areaControll.includes('step_box2-1')
                                           ||<EquipOperSp 
                                            spPrechkList={spPrechkList} 
                                            equipOperSpList={equipOperSpList}
                                            spChkData={spChkData}
                                            setSpChkData={setSpChkData}
                                            viewMode={false}
                                            />
                                        }
                                    </div>
                                }


                                <div className="step_tt">
                                    <h4><span>STEP 3</span>{G.t('trem.lang.home.0095')}</h4>{/* <h4><span>STEP 3</span>부가서비스, 실험재료 선택</h4> */}
                                    <div className="box_btn">
                                    {
                                        areaControll.includes('step_box3')
                                        ?<a href="javascript:void(0);" className="close" onClick={()=>{areaControllFn("step_box3", false)}} >열기</a>
                                        :<a href="javascript:void(0);" className="open" onClick={()=>{areaControllFn("step_box3",true)}}>닫기</a>
                                    }
                                    </div>
                                </div>
                                { 
                                    areaControll.includes('step_box3')
                                    ||<EquipMro handleChangeData={handleChangeData} dataStore={dataStore} />
                                }
                                
                                <h5 className="tt_type3"><label htmlFor="QUENTITY_NAME">{G.t('trem.lang.home.0103')}</label></h5>{/* 시료명 */}
                                <input 
                                    type="text" id="QUENTITY_NAME" className="input_type1" name="QUENTITY_NAME"
                                    placeholder={G.t('trem.lang.home.0104')}/* 시료명을 입력해주세요 */
                                    title={G.t('trem.lang.home.0103')}/* 시료명 */
                                    onChange={handleChangeData}
                                />
                                
                                {equipOperInfo.FORM_STATUS === 'A' 
                                && <Fragment>
                                    <h5 className="tt_type3"><label htmlFor="FORM_SKEY">{G.t('trem.lang.home.0762')}</label></h5> {/* 시험분석의뢰서 */}
                                    <div className="form_content_wrap mb-6">
                                        <form ref={formRef}>
                                            <input type="hidden" id="FORM_SKEY" name="FORM_SKEY" value={equipOperInfo.FORM_SKEY} />
                                            <div dangerouslySetInnerHTML={{ __html: equipOperInfo.FORM_CONTENT}} className="t_gray_box"/>
                                        </form>
                                    </div>
                                </Fragment>
                                }

                                {paramData.BOOKING_TYPE == 'EX'
                                && <Fragment>
                                    <h5 className="tt_type3">{G.t('trem.lang.home.0297')}</h5>
                                    <div className="flex flex-row mb-6">
                                        <div className="e_option" role="group" style={{width: "auto", paddingTop: "10px"}}>
                                            <input title="전문가 자동 선택" type="radio" name="EXPERT_TYPE" value="A" id="TYPE1" checked={"A" === paramData.EXPERT_TYPE} onChange={handleChangeData}/>
                                            <label htmlFor="TYPE1">{G.t('trem.lang.home.0763')}</label> {/* 자동 */}
                                            <input title="전문가 직접 선택" type="radio" name="EXPERT_TYPE" value="D" id="TYPE2" checked={"D" === paramData.EXPERT_TYPE} onChange={handleChangeData}/>
                                            <label htmlFor="TYPE2">{G.t('trem.lang.home.0764')}</label>
                                        </div>
                                        {paramData.EXPERT_TYPE === 'D'
                                        && <div className="search_box2 expertBox">
                                            <input title="검색어 입력" type="text" name="EXPERT_NAME" value={paramData.EXPERT_NAME} readOnly={true}/>
                                            <a href="javascript:void(0);" onClick={() => expertPopupProps.setOpen(true)}>{G.t('trem.lang.home.0036')}</a>{/* 검색 */}
                                            
                                        </div>
                                        }
                                    </div>
                                </Fragment>
                                }

                                <h5 className="tt_type3">
                                    {G.t('trem.lang.home.0240')}
                                    {/*첨부파일*/}
                                    {equipOperInfo.FLAG_ATTACH_FILE==="Y" && ( <span className="t_red"> 필수 등록 </span> )}
                                </h5>
                                <div className="attach_box p-3" >
                                    <FileUploader 
                                        attachFileInfo={attachFileInfo} 
                                        setAttachFileInfo={setAttachFileInfo}
                                    />
                                </div>
                                <h5 className="tt_type3"><label htmlFor="NOTE">{G.t('trem.lang.home.0673')}</label></h5> {/*비고*/}
                                <textarea 
                                    id="NOTE"
                                    name="NOTE" 
                                    className="textarea1" 
                                    title={G.t('trem.lang.home.0074')}/* 비고 */
                                    onChange={handleChangeData}
                                >{paramData.NOTE}</textarea>
                            </div>
                        </Fragment>
                        }
                    

                    <div className="btn_type1">
                        {equipOperInfo.FLAG_NOT_USE === 'Y' ? (
                            <Fragment>
                                <p className="t_red">{G.t('trem.lang.home.0765')}</p> {/* 장비예약 권한이 없습니다. */}
                                <a href="javascript:void(0);" className="red_r">
                                    <span>X</span>{G.t('trem.lang.home.0088')}{/* 예약불가 */}
                                </a>
                            </Fragment>
                        ) : requesterUserInfo.FLAG_PRE_FUA === 'Y' &&
                          requesterUserInfo.FLAG_CHECK_FUA === 'N' ? (
                            <Fragment>
                                <p>
                                    <span className="text-red-500">
                                        {requesterUserInfo.FACIL_NAME}
                                    </span>{' '}
                                    - {G.t('trem.lang.home.0766')} {/* 시설 이용권한이 없어 예약할 수 없습니다. */}
                                </p>
                                <a href="javascript:void(0);" className="red_r">
                                    <span>X</span>{G.t('trem.lang.home.0088')}{/* 예약불가 */}
                                </a>
                            </Fragment>
                        ) : (/*선점예약 체크*/
                            paramData.FLAG_PREEMPTIVE != "Y"
                            || (paramData.FLAG_PREEMPTIVE === 'Y' && paramData.PREEMPTIVE_SKEY)
                        ) ? (
                            <a href="javascript:void(0);" className="red" onClick={requestReservation}>
                                {G.t('trem.lang.home.0108')}{/* 예약신청 */}
                            </a>
                        )
                        : ''
                        }
                    </div>
                </div>
            </div>
            
            {/*popup*/}
            {userPopupProps.open && (
                <ModalBox {...userPopupProps} buttons={useButtons}>
                    <PopupUserSelect getPopupValue={getUsePopupValue}/>
                </ModalBox>
            )}
            <div>
                <ReservCharge {...reservChargeProps}/>
            </div>
            {/* <div>
                <UserPopup {...userPopupProps} />
            </div> */}
            <div>
                <DeptPopup {...deptPopupProps} />
            </div>
            <div>
                {expertPopupProps.open && (
                    <ModalBox {...expertPopupProps}
                        EQUIP_SKEY={params?.EQUIP_SKEY} 
                        buttons={expertButtons}>
                        <PopupExpertSelect />
                    </ModalBox>
                )}
            </div>
            
            { companyCheckPopupProps.open &&
            <ModalBox {...companyCheckPopupProps} handleClose={()=>{alert(G.t('trem.lang.home.0958'))}} buttons={companyCheckPopupButtons} width="400" height="200">
                <div>
                    <div style={{textAlign:'center'}}>
                        <p>
                            마이페이지 회원정보에서 <br/>소속정보를 입력해 주시기바랍니다.
                        </p>
                    </div>
                </div>
            </ModalBox>}

            { blackPopupProps.open &&
            <ModalBox {...blackPopupProps} handleClose={()=>{alert(G.t('trem.lang.home.0958'))}} buttons={blackPopupButtons} width="600" height="350">
                <div>
                    <div>
                        <p>
                        귀하의 소속기관은 본 센터의 연구시설/장비와 관련한 규정 위반으로 모든 장비 이용이 제한됩니다.<br/>
                        벌점 부과 내역은 "TREE 메인&gt;마이페이지&gt;벌점 현황" 메뉴를 통해 확인하시기 바랍니다.<br/>
                        특히, 이용료 미납 시 납부 완료될 때까지 모든 장비 이용이 제한됩니다.<br/>
                        미납요금 납부 후 제한 해제 요청(문의)은 사업운영팀 임현경 연구원(02-2200-3336)으로 연락주시기 바랍니다.<br/>
                        그 밖의 센터의 관련 규정은 "TREE 메일&gt;공지사항&gt;규정 및 정책" 메뉴에서 확인 하실 수 있습니다.
                        </p>
                    </div>
                </div>
            </ModalBox>}
               
           
        </Fragment>
    )
}